import {
    Brands,
    ChampionshipReigns,
    Championships,
    Companies,
    CompanyAlerts,
    CompanyLogs,
    db,
    deleteDb,
    Drafts,
    Events,
    Facilities,
    Factions,
    FeudItems,
    Feuds,
    Games,
    GimmickMatches,
    Gimmicks,
    loadDb,
    MatchContracts,
    Matches,
    Messages,
    Negotiations,
    NewsItems,
    Objectives,
    Powerups,
    Properties,
    RandomEvents,
    Relationships,
    Rosters,
    Scenarios,
    SegmentItems,
    Segments,
    StaffMembers,
    StoryChoices,
    Streaks,
    Superstars,
    TagTeams,
    TalentRequests,
    Tournaments,
    TradeOffers,
    YearlyRankings
} from "../models/models.js";
import {Scenario, setScenarioGame} from "../models/scenario.js";
import {
    addSuperstarChampionshipReigns,
    addSuperstarChampionships,
    addSuperstarGimmicks,
    addSuperstarMatchContracts,
    addSuperstarNegotiations,
    addSuperstarRandomEvents,
    addSuperstarRelationships,
    addSuperstarStreaks,
    addSuperstarTalentRequests,
    addSuperstarWonTournaments,
    getSuperstarTagTeams,
    setSuperstarManager,
    Superstar
} from "../models/superstar.js";
import {
    addTagTeamMatchContracts,
    addTagTeamNegotiations,
    addTagTeamStreaks,
    addTagTeamSuperstars,
    addTagTeamTalentRequests,
    addTagTeamWonTournaments,
    TagTeam
} from "../models/tagTeam.js";
import {
    addChildEvent,
    addEventMatchContracts,
    addEventMatches,
    addEventSegments,
    addEventStreaks,
    addEventTournaments,
    Event,
    getEventMatches,
    getEventSegments
} from "../models/event.js";
import {
    addChampionshipChampionshipReigns,
    addChampionshipMatchContracts,
    addChampionshipRandomEvents,
    Championship
} from "../models/championship.js";
import {
    addGameCompanies,
    addGameYearlyRankings,
    Game,
    getGameCompanies, getGameCurrentCompany,
    setGameCurrentCompany
} from "../models/game.js";
import {
    addRosterBrands,
    addRosterFactions,
    addRosterFeuds,
    addRosterGimmicks,
    addRosterOriginalSuperstars,
    addRosterStaff,
    addRosterSuperstars,
    addRosterTagTeams,
    getRosterBrands,
    getRosterFactions,
    getRosterFeuds,
    getRosterSuperstars,
    getRosterTagTeams, removeRosterBrands,
    Roster
} from "../models/roster.js";
import {
    addCompanyChampionships,
    addCompanyCompanyAlerts,
    addCompanyCompanyLogs,
    addCompanyEvents,
    addCompanyFacilities,
    addCompanyFeudItems,
    addCompanyGimmickMatches,
    addCompanyMessages,
    addCompanyNewsItems,
    addCompanyObjectives,
    addCompanyPowerups,
    addCompanyRandomEvents,
    addCompanyReceivedNegotiations,
    addCompanyReceivedTradeOffers,
    addCompanyRelationships,
    addCompanyRosters,
    addCompanySegmentItems,
    addCompanySentNegotiations,
    addCompanySentTradeOffers,
    addCompanyStaff,
    addCompanyStoryChoices,
    addCompanyTalentRequests,
    addCompanyTournaments,
    Company,
    getCompanyChampionships,
    getCompanyDraft,
    getCompanyEvents, getCompanyFacilities, getCompanyFeudItems,
    getCompanyMessages, getCompanyPowerups, getCompanyRandomEvents,
    getCompanyReceivedNegotiations, getCompanyReceivedTradeOffers,
    getCompanyRosters, getCompanySegmentItems,
    getCompanySentNegotiations, getCompanySentTradeOffers,
    getCompanyStaff, getCompanyStoryChoices,
    getCompanyTalentRequests,
    getCompanyTournaments, removeCompanySegmentItems
} from "../models/company.js";
import {
    addMatchChampionshipReigns,
    addMatchChampionships,
    addMatchFeuds,
    addMatchSuperstars,
    addMatchTagTeams,
    Match
} from "../models/match.js";
import {Brand} from "../models/brand.js";
import {
    asyncFor,
    captureError, eventPrestigeXps,
    fanLevels,
    gameLimits, generateUUID,
    getArrayMaxByProperty,
    getCurrentGame, getMonthsDifference,
    getRandomChoice,
    getRandomInt,
    getRandomUniform,
    getRosterMemberPronoun,
    getTimeDiffHuman,
    myround, staffRoles
} from "./helpers.js"
import {getRankFromPopularity, getRosterMemberSuperstars} from "./superstars.js"
import {
    addNewCompanyStaffAndFacilities, formNewCompany,
    getBuyoutData,
    getCompanyLatestEvent, getCompanyMonth,
    getCompanyParentEvents,
    getCompanyRosterByType,
    getCompanyRosterCapacity,
    getCompanyUnreadMessages,
    getCpuControlledCompanies,
    getCurrentMonth, getNewCompanySelectionsData, getTutorialStateName,
    processSuperstarsYearlyChanges, reviewObjectives,
    runningBuyoutCheck
} from "./companies.js"
import {getEventCardData, getEventHype} from "./events.js"
import {globals, globalUser} from "./globals.js";
import {getDashboardData} from "./dashboard.js";
import {addFactionSuperstars, Faction, setFactionLeaderSuperstar} from "../models/faction.js";
import {CompanyAlert} from "../models/companyAlert.js";
import {setStaffSuperstarObject, Staff} from "../models/staff.js";
import {ChampionshipReign} from "../models/championshipReign.js";
import {CompanyLog} from "../models/companyLog.js";
import {Message} from "../models/message.js";
import {Powerup} from "../models/powerup.js";
import {Facility} from "../models/facility.js";
import {addSegmentFeuds, addSegmentSuperstars, addSegmentTagTeams, Segment} from "../models/segment.js";
import {MatchContract} from "../models/matchContract.js";
import {Streak} from "../models/streak.js";
import {addFeudFactions, addFeudSuperstars, addFeudTagTeams, Feud} from "../models/feud.js";
import {addObjectiveProperties, Objective} from "../models/objective.js";
import {
    addPropertyChampionships,
    addPropertyGimmickMatches,
    addPropertySuperstars,
    Property
} from "../models/property.js";
import {addGimmickMatchMatches, addGimmickMatchRandomEvents, GimmickMatch} from "../models/gimmickMatch.js";
import {Relationship} from "../models/relationship.js";
import {addRandomEventMessages, RandomEvent} from "../models/randomEvent.js";
import {getNegotiationTalent, Negotiation} from "../models/negotiation.js";
import {addTradeOfferOfferedSuperstars, addTradeOfferRequestedSuperstars, TradeOffer} from "../models/tradeOffer.js";
import {TalentRequest} from "../models/talentRequest.js";
import {
    addTournamentChampionships,
    addTournamentMatchContracts,
    addTournamentMatches,
    Tournament
} from "../models/tournament.js";
import {addFeudItemFeuds, FeudItem} from "../models/feudItem.js";
import {addSegmentItemSegments, SegmentItem} from "../models/segmentItem.js";
import {NewsItem} from "../models/newsItem.js";
import {StoryChoice} from "../models/storyChoice.js";
import {YearlyRanking} from "../models/yearlyRanking.js";
import {addDraftCompanies, addDraftRosters, Draft, setDraftCurrentPickRoster} from "../models/draft.js";
import {Gimmick} from "../models/gimmick.js";
import {getTalentOfferData} from "./negotiations.js";
import {getTalentRequestData} from "./talentRequests.js";
import {talentRequestsData} from "../data/talentRequests.js";
import {createCustomCompanyDraft, createDraft, getDraftData, processDraftPick} from "./draft.js";
import {getAnnualTournamentData} from "./annualTournament.js";
import {processYearlyRanking} from "./rankings.js";
import {getPartTimerAppearances, transferTalentToRoster} from "./rosters.js";
import {checkAreChampionshipsEqual} from "./championships.js";
import {gimmickMatchUnlocksData} from "../data/gimmickMatchUnlocks.js";
import {standardFeudItemsData} from "../data/feudItems.js";
import {standardSegmentItemsData} from "../data/segmentItems.js";
import {standardPowerupsData} from "../data/powerups.js";
import {filterCompetitorPowerups, generateCompany, generateStaffMember, generateSuperstar} from "./generate.js";
import {
    checkForAvailableCallupsMessage,
    checkToAddCurrentObjectivesMessage,
    createCustomStartingCompanyCompetitorMessage,
    createIntroducePowerupsSandboxModeMessage,
    createIntroduceSandboxModeMessage,
    createJoinedCompanySuperstarMessage,
    createNewCompanyDoctorMessage, createNewCompanyProducerMessage,
    createNewCompanyScoutMessage, createNewCompanyTalentManagerMessage,
    createNewCompanyTrainerMessage
} from "./messages.js";
import {generateCompanyObjectives} from "./objectives.js";
import {standardGimmickMatchesData} from "../data/gimmickMatches.js";
import {loadUser, saveUser} from "./user.js";
import {getRandomEventData} from "./randomEvents.js";
import {getTradeOfferData} from "./trades.js";
import {createFemmeFataleMatch, createPowObjectives, getPowProducerReactionDialogs} from "./passionOfWrestling.js";
import {removeObjectBrand} from "./brands.js";

async function createGame(gameData, newGameSettings = null) {
    // Duplicates game and saves to database. Used in import web game,
    // download web scenario (createScenarioFromScenarioData), create game from scenario.
    // newGameSettings parameter sets properties for new game (last played, randomness etc)

    const gameDetails = gameData['gameDetails'];
    const game = {...Game(), ...gameDetails};
    const user = loadUser();
    game.userUid = user?.uid;
    if (newGameSettings) {
        let mainCompanyDetails = gameData.companies[0].companyDetails;
        game.datetimeLastPlayed = Date.now();
        game.numberOfWeeklyShows = mainCompanyDetails.storyName === 'mars' ? 0 :
            newGameSettings['numberOfWeeklyShows'];
    }
    await Games.insert(game);

    let allBrandNames = [];
    let draftAvailableSuperstars = [];
    let draftAvailableTagTeams = [];
    let gameDataCompetitors = gameData['companies'].slice(1);

    // Get starting event index, remove extra event from main company
    let startingEventIndex;
    if (newGameSettings) {
        startingEventIndex = gameData.companies[0].events.slice(0, 12).map(x => x.name)
            .indexOf(gameData.companies[0].events[gameData.companies[0].events.length - 1].name);
        if (startingEventIndex === -1) {
            startingEventIndex = 0  // in case starting event not set in editor
        }
        gameData.companies[0].events = gameData.companies[0].events.slice(0, 12);
    }

    if (newGameSettings) {

        // Set sandbox mode settings
        if (newGameSettings['gameModeOption'] === 'sandbox') {
            game.settings['sandbox_mode_enabled'] = true;

            // User specified settings
            const sandboxSettings = ['unlimited_creative_points', 'maximum_roster_capacity', 'all_indies_available',
                'unlock_all_items', 'maximum_staff_and_facilities', 'no_special_items_cooldown',
                'no_injuries', 'no_unhappiness', 'no_talent_requests', 'no_random_events',
                'no_retirements', 'no_going_part_time'];
            let sandboxModeOptions = newGameSettings['sandboxModeOptions'];
            for (const sandboxSetting of sandboxSettings) {
                game.settings[sandboxSetting] = !!(sandboxModeOptions && sandboxModeOptions.includes(sandboxSetting));
            }
        }

        // Get starting company
        let startingCompany;
        if (newGameSettings['playerModeOption'] === 'local-multiplayer') {
            // If local multiplayer mode, set first user company as starting company
            startingCompany = gameData['companies']
                .find(x => x.companyDetails.name === newGameSettings['selectedUserCompanies'][0]);
        }
        else if (newGameSettings['customStartingCompanyData']) {
            // Create custom company data
            let customStartingCompanyData = newGameSettings['customStartingCompanyData'];
            let companyDetails = {};
            const customCompanyFinances = {'weak': 150, 'average': 500, 'strong': 2000, 'loaded': 10000};
            const customCompanySize = {'backyard': 1, 'indie': 4, 'national': 7, 'global': 10};
            companyDetails.name = customStartingCompanyData.companyName;
            companyDetails.ownerName = customStartingCompanyData.ownerName;
            companyDetails.weeklyShowName = customStartingCompanyData.weeklyShowName;
            companyDetails.style = customStartingCompanyData.companyStyle;
            companyDetails.points = customCompanyFinances[customStartingCompanyData.companyFinances];
            companyDetails.reputation = customCompanySize[customStartingCompanyData.companySize];
            companyDetails.fans = fanLevels[companyDetails.reputation - 1];

            // Add rosters data
            let rostersData = [];
            for (let type of ['main', 'training', 'trainingAvailable', 'trainingFuture']) {
                let rosterData = {'type': type, 'superstars': [], 'tagTeams': [], 'factions': [], 'brands': []};
                rostersData.push(rosterData);
            }

            // Add generated main roster superstars data
            if (customStartingCompanyData['talentOption'] === 'generate') {
                let rosterCapacity = getCompanyRosterCapacity(companyDetails, game);

                let rosterSuperstars = [];
                for (let y = 0; y < Math.floor(rosterCapacity * getRandomUniform(0.65, 0.85)); y++) {
                    let newSuperstar = await generateSuperstar({indie: true, insert: false, generateGimmick: false});
                    rosterSuperstars.push(newSuperstar);
                }
                let mainRoster = rostersData.find(x => x.type === 'main');
                mainRoster.superstars = JSON.parse(JSON.stringify(rosterSuperstars));
            }

            // Add generated training roster superstars data
            if (customStartingCompanyData['trainingRosterOption'] === 'generate') {
                let trainingRosterSuperstars = [];
                for (let y of Array(getRandomInt(10, 15)).keys()) {
                    let newSuperstar = await generateSuperstar({insert: false, generateGimmick: false});
                    trainingRosterSuperstars.push(newSuperstar);
                }
                let trainingRoster = rostersData.find(x => x.type === 'training');
                trainingRoster.superstars = JSON.parse(JSON.stringify(trainingRosterSuperstars));
            }

            // Add championships data
            let divisionChampionshipsData = {'singles': 1, 'tag-team': 2, 'trio': 3};
            let prestigeXps = {'A': 300, 'B': 100, 'C': 0};
            let championshipsData = [];
            for (let [i, y] of customStartingCompanyData['companyChampionshipsData'].entries()) {
                let divisionChampionships = divisionChampionshipsData[y['division']] || 1;

                // Get graphic if present
                let graphic = null;
                if (y['graphic']) {
                    graphic = JSON.parse(y['graphic']);
                }

                // Get rank
                let rankName;
                if (i === 0) {
                    rankName = 'Main Eventer';
                } else {
                    rankName = 'Upper Midcarder';
                }

                // Create championships and add to roster
                for (let z of Array(divisionChampionships).keys()) {
                    let championshipData = {};
                    championshipData.name = y['name'];
                    championshipData.rank = rankName;
                    championshipData.vacated = true;
                    if (graphic) {
                        championshipData.graphic = graphic;
                    }
                    if (y['division'] === 'tag-team') {
                        championshipData.tagTeam = true;
                    } else if (y['division'] === 'trio') {
                        championshipData.trio = true;
                    }
                    championshipData.prestige = y['prestige'];
                    championshipData.highestPrestige = y['prestige'];
                    championshipData.xp = prestigeXps[y['prestige']] || 0;
                    championshipsData.push(championshipData);
                }
            }

            // Add events data
            let eventsData = [];
            for (let y of customStartingCompanyData['companyMonthlyEventsData']) {
                let eventData = {
                    'name': y['name'], 'prestige': y['prestige'], 'xp': eventPrestigeXps[y['prestige']] || 0,
                    'matchContracts': [], 'streaks': []
                }
                eventsData.push(eventData);
            }

            // Add gimmick matches data
            let gimmickMatchesData = JSON.parse(JSON.stringify(standardGimmickMatchesData));

            // Add custom company data to gameCompanies, set as starting company
            startingCompany = {'companyDetails': companyDetails, 'championships': championshipsData, 'events': eventsData,
                'gimmickMatches': gimmickMatchesData, 'rosters': rostersData};
            gameData['companies'].push(startingCompany);
        }
        else if (newGameSettings['startingCompanyName']) {
            startingCompany = gameData['companies']
                .find(x => x.companyDetails.name === newGameSettings['startingCompanyName']);
        }

        // Process starting company if different from first company
        if (startingCompany && startingCompany !== gameData['companies'][0]) {
            // Move indie rosters to new starting company
            let firstCompany = gameData['companies'][0];
            let indieRosters = firstCompany.rosters
                .filter(x => ['indie', 'indieAvailable', 'indieFuture'].includes(x.type));
            firstCompany.rosters = firstCompany.rosters
                .filter(x => !indieRosters.includes(x))
            startingCompany.rosters.push(...indieRosters);
            startingCompany.companyDetails.realYear = firstCompany.companyDetails.realYear;

            // Move starting company to start of companies
            gameData['companies'].sort(function (a, b) {
                return a.companyDetails.name === startingCompany.companyDetails.name ? -1 :
                    b.companyDetails.name === startingCompany.companyDetails.name ? 1 : 0;
            });
        }

        // Get competitors
        gameDataCompetitors = gameData['companies'].slice(1);
        let originalCompetitors = [...gameDataCompetitors];
        if (newGameSettings['playerModeOption'] === 'local-multiplayer') {
            // Filter competitors if local multiplayer
            gameDataCompetitors = gameDataCompetitors.filter(x =>
                newGameSettings['selectedUserCompanies'].concat(newGameSettings['selectedCPUCompanies'])
                    .includes(x.companyDetails.name))
        }
        else if (newGameSettings['selectedCompetitorsNames'] && !newGameSettings['editOption']) {
            // Filter competitors based on selections
            gameDataCompetitors = gameDataCompetitors.filter(x => newGameSettings['selectedCompetitorsNames'].includes(x.companyDetails.name));
        }
        else {
            if (newGameSettings['competitorsOption'] === 'generate') {
                gameDataCompetitors = [];
            } else if (newGameSettings['competitorsOption'] === 'none') {
                gameDataCompetitors = [];
            }
        }
        gameDataCompetitors = gameDataCompetitors.slice(0, gameLimits.maxCompetitors);

        // Set competitorsPresent
        game.competitorsPresent = gameDataCompetitors.length > 0 || newGameSettings['competitorsOption'] === 'generate';

        // Send unselected competitors' superstars to indie roster
        let unselectedCompetitors = originalCompetitors.filter(x => !gameDataCompetitors.includes(x));
        if (unselectedCompetitors.length && newGameSettings['competitorsOption'] !== 'generate' && globalUser.paid) {
            let indieRoster = gameData['companies'][0].rosters.find(x => x.type === 'indie');
            let indieFutureRoster = gameData['companies'][0].rosters.find(x => x.type === 'indieFuture');
            for (let unselectedCompetitor of unselectedCompetitors) {
                let currentRosters = unselectedCompetitor.rosters
                    .filter(x => ['main', 'training'].includes(x.type));
                for (let currentRoster of currentRosters) {
                    indieRoster.superstars.push(...currentRoster.superstars);
                    indieRoster.tagTeams.push(...currentRoster.tagTeams);
                }

                let futureRoster = unselectedCompetitor.rosters.find(x => x.type === 'trainingFuture');
                if (futureRoster && indieFutureRoster) {
                    indieFutureRoster.superstars.push(...futureRoster.superstars);
                    indieFutureRoster.tagTeams.push(...futureRoster.tagTeams);
                }
            }
        }
    }

    // Create companies with rosters (to add superstars and tag teams first for matches and other relationships)
    let gameCompanies = [];
    let gameDataCompanies = [gameData['companies'][0], ...gameDataCompetitors];
    for (let i = 0; i < gameDataCompanies.length; i++) {
        const companyData = gameDataCompanies[i];
        const company = await createGameCompanyWithRosters(companyData, newGameSettings, allBrandNames,
            draftAvailableSuperstars, draftAvailableTagTeams);
        gameCompanies.push(company);
    }
    await addGameCompanies(game, gameCompanies);
    let mainUserCompany = gameCompanies[0];
    mainUserCompany.userControlled = true;

    // Set current company
    if (game['currentCompanyUid']) {
        const gameCurrentCompany = gameCompanies.find(x => {
            return x.uid === game.currentCompanyUid;
        });
        if (gameCurrentCompany) {
            await setGameCurrentCompany(game, gameCurrentCompany);
        }
        delete game.currentCompanyUid;
    }

    // Get all superstars and teams
    let [allRosters, allFactions, allFeuds, allBrands] = await getRosterObjects(gameCompanies);

    // Add original superstars relationship
    if (!newGameSettings) {
        for (const roster of allRosters) {
            if (roster['originalSuperstarsUids'].length > 0) {
                const rosterOriginalSuperstars = Superstars.find({'uid': {'$in': roster['originalSuperstarsUids']}});
                if (rosterOriginalSuperstars.length > 0) {
                    await addRosterOriginalSuperstars(roster, rosterOriginalSuperstars);
                }
                if (roster['originalSuperstarsUids'].length !== rosterOriginalSuperstars.length) {
                    console.log('original superstars not found when creating roster', roster, roster.originalSuperstarsUids)
                }
            }
        }
    }

    // Add managers
    if ((!newGameSettings || newGameSettings['mainRostersOption'] !== 'draft') && globalUser.paid) {
        for (const rosterSuperstar of Superstars.find({})) {
            if (rosterSuperstar['managerUid'] && !rosterSuperstar.monthToAppearIn) {
                const superstarManager = Superstars.findOne({
                    'uid': rosterSuperstar.managerUid
                });
                if (superstarManager && !superstarManager.monthToAppearIn) {
                    await setSuperstarManager(rosterSuperstar, superstarManager);
                }
                delete rosterSuperstar.managerUid;
            }
        }
    }

    // Add tag team superstars
    for (const tagTeam of TagTeams.find({})) {
        const tagTeamSuperstars = Superstars.find({'uid': {'$in': tagTeam['superstarUids']}}).filter(x => !x.monthToAppearIn);
        if (tagTeamSuperstars.length) {
            addTagTeamSuperstars(tagTeam, tagTeamSuperstars);
        }
        if (tagTeam['superstarUids'].length !== tagTeamSuperstars.length) {
            console.log('superstars not found when creating tagTeam', tagTeam, tagTeam.superstarUids);
            if (!tagTeamSuperstars.length) {
                TagTeams.remove(tagTeam);
            }
        }
        delete tagTeam.superstarUids;
    }

    // Add faction superstars
    for (const faction of Factions.find({})) {
        const factionSuperstars = Superstars.find({'uid': {'$in': faction['superstarUids']}}).filter(x => !x.monthToAppearIn);
        if (factionSuperstars.length) {
            await addFactionSuperstars(faction, factionSuperstars);

            // Add leader superstar
            if (faction.leaderSuperstarUid) {
                const leaderSuperstar = factionSuperstars.find(x => {
                    return x.uid === faction.leaderSuperstarUid;
                });
                if (leaderSuperstar) {
                    setFactionLeaderSuperstar(faction, leaderSuperstar);
                }
                else {
                    console.log('leader not found when creating game', faction)
                }
                delete faction.leaderSuperstarUid;
            }
        }
        if (faction['superstarUids'].length !== factionSuperstars.length) {
            console.log('superstars not found when creating faction', faction, faction.superstarUids);
            if (!factionSuperstars.length) {
                Factions.remove(faction)
            }
        }
        delete faction.superstarUids;
    }

    // Add brand uids to company settings
    for (const company of gameCompanies) {
        if (company.settings['yearly_brand_draft_settings'] &&
            Object.keys(company.settings['yearly_brand_draft_settings']).length !== 0) {
            for (const [i, brandUid] of company.settings['yearly_brand_draft_settings']['brandUids'].entries()) {
                let draftBrand = allBrands.find(x => {
                    return x.uid === brandUid;
                });
                if (draftBrand) {
                    company.settings['yearly_brand_draft_settings']['brandUids'][i] = draftBrand.$loki;
                }
                else {
                    company.settings['yearly_brand_draft_settings']['brandUids'].splice(i, 1)
                }
            }
        }
    }

    // Create events and championships
    let allSegments = [];
    let allMatches = [];
    let allChampionships = [];
    for (let i = 0; i < gameDataCompanies.length; i++) {
        const companyData = gameDataCompanies[i];
        const company = gameCompanies[i];
        let otherObjects = await createGameCompanyOtherObjects(company, companyData,
            allFactions, allFeuds, allBrands, allRosters, startingEventIndex, newGameSettings, game,
            gameData['favoritedCommunitySegments'], mainUserCompany.storyName);
        allSegments.push(...otherObjects[0]);
        allMatches.push(...otherObjects[1]);
        allChampionships.push(...otherObjects[2]);
    }

    // Add feud participants
    for (const feud of Feuds.find({})) {
        let feudParticipants = [];
        if (feud['type'] === 'singles') {
            feudParticipants = Superstars.find({'uid': {'$in': feud.participantUids}});
            await addFeudSuperstars(feud, feudParticipants);
        } else if (feud['type'] === 'faction') {
            feudParticipants = Factions.find({'uid': {'$in': feud.participantUids}});
            await addFeudFactions(feud, feudParticipants);
        } else {
            feudParticipants = TagTeams.find({'uid': {'$in': feud.participantUids}});
            await addFeudTagTeams(feud, feudParticipants);
        }
        if (feudParticipants.length !== feud.participantUids.length) {
            console.log('feud participants not found when creating feud', feud.participants, feud.participantUids)
        }

        delete feud.participantUids;
    }

    if (newGameSettings) {

        // Generate competitors
        if (newGameSettings['competitorsOption'] === 'generate') {
            // Get starting event index
            const parentEvents = await getCompanyParentEvents(mainUserCompany);
            const nextEvent = await getCompanyLatestEvent(mainUserCompany);
            const startingEventIndex = parentEvents.map(x => x.name).indexOf(nextEvent.name);
            let existingCompanyNames = gameCompanies.map(x => x.name);

            for (let x of Array(getRandomInt(2, 5)).keys()) {
                const newCompetitor = await generateCompany({
                    startingEventIndex, existingCompanyNames: existingCompanyNames, uncommonNames: true,
                    mainRostersOption: newGameSettings['mainRostersOption'], month: game.monthCount, year: game.year,
                    realYear: mainUserCompany.realYear, game
                });
                newCompetitor.overness = getRandomInt(25, 75);
                gameCompanies.push(newCompetitor);
                await addGameCompanies(game, [newCompetitor]);
                existingCompanyNames.push(newCompetitor.name);

                if (newGameSettings['mainRostersOption'] === 'draft') {
                    let mainRoster = await getCompanyRosterByType(newCompetitor, 'main');
                    draftAvailableSuperstars.push(...(await getRosterSuperstars(mainRoster)));
                    draftAvailableTagTeams.push(...(await getRosterTagTeams(mainRoster)));
                }
            }
        }

        // Set market size
        if (mainUserCompany.storyName !== 'mars' && game.competitorsPresent &&
            (globalUser.paid || mainUserCompany.storyName === 'tutorial')) {
            if (game.marketSize === null) {
                game.marketSize = 4000000;  // Default market size
            }
        }
        else {
            game.marketSize = null;
        }

        // Divide market between competitors, depending on number of fans
        if (game.marketSize) {
            // Add fans/xp based on market size
            const reputationXpLevels = {
                1: 0, 2: 10, 3: 30, 4: 60, 5: 100, 6: 150, 7: 210, 8: 280, 9: 360, 10: 450, 11: 550
            };
            let totalFans = gameCompanies.reduce((n, {fans}) => n + fans, 0);
            for (const company of gameCompanies) {
                company.fans = (company.fans / totalFans) * game.marketSize;
                company.fans = myround(company.fans, 1000);
                if (company.fans < 20000) {
                    company.fans = 20000
                }
                company.xp = reputationXpLevels[company.reputation];
                // Add 10% xp to next reputation so it doesn't drop right after starting game
                company.xp += (reputationXpLevels[company.reputation + 1] - company.xp) / 10.0;
            }
        }

        // Move some superstars to training / indie available rosters
        for (const gameCompany of gameCompanies) {
            let trainingRoster = await getCompanyRosterByType(gameCompany, 'training');
            let trainingAvailableRoster = await getCompanyRosterByType(gameCompany, 'trainingAvailable');
            for (let i of Array(2).keys()) {
                const talentToTransfer = getRandomChoice(await getRosterSuperstars(trainingRoster));
                if (talentToTransfer) {
                    await transferTalentToRoster(talentToTransfer, trainingAvailableRoster);
                }
            }
        }
        let indieRoster = await getCompanyRosterByType(mainUserCompany, 'indie');
        let indieAvailableRoster = await getCompanyRosterByType(mainUserCompany, 'indieAvailable');
        if (newGameSettings['mainRostersOption'] !== 'draft' && !newGameSettings['all_indies_available'] &&
            (!newGameSettings['customStartingCompanyData'] ||
                newGameSettings['customStartingCompanyData']['talentOption'] !== 'draft')) {
            for (let i of Array(3).keys()) {
                const talentToTransfer = getRandomChoice(await getRosterSuperstars(indieRoster));
                if (talentToTransfer) {
                    await transferTalentToRoster(talentToTransfer, indieAvailableRoster);
                }
            }
        }

        // Set local multiplayer attributes
        let userControlledCompanies = gameCompanies.filter(x => x.userControlled);
        if (newGameSettings['playerModeOption'] === 'local-multiplayer') {
            game.settings['control_multiple_companies'] = true;
            game.settings['number_of_user_companies'] = userControlledCompanies.length;

            // Add player names and set turn status
            for (const [i, y] of userControlledCompanies.entries()) {
                if (newGameSettings['playerNames'][i]) {
                    y.playerName = newGameSettings['playerNames'][i]
                }
                else {
                    y.playerName = `Player ${i + 1}`
                }
                y.turnStatus = 'playing';
            }
        }

        // Add objectives for POW
        if (mainUserCompany.storyName === 'passion') {
            let objectives = await createPowObjectives(mainUserCompany);
            await addCompanyObjectives(mainUserCompany, objectives);
        }

        // Add first tutorial state for tutorial
        if (mainUserCompany.storyName === 'tutorial') {
            const storyChoice = StoryChoice();
            StoryChoices.insert(storyChoice);
            storyChoice.choice = 'add_singles_match';
            await addCompanyStoryChoices(mainUserCompany, [storyChoice]);

            // Disable first callup
            mainUserCompany.trainingCallupRun = true;
        }

        // Add draft if selected and competitors present
        if (newGameSettings['mainRostersOption'] === 'draft' && game.competitorsPresent) {
            // Move all draft superstars/tagTeams to indie available roster
            await addRosterSuperstars(indieAvailableRoster, draftAvailableSuperstars);
            for (let s of draftAvailableSuperstars) {
                s.brandName = null;
            }
            await addRosterTagTeams(indieAvailableRoster, draftAvailableTagTeams);

            // Create draft
            let draft = await createDraft(mainUserCompany, gameCompanies);
            await processDraftPick(draft, draftAvailableSuperstars);
        }
        // Add custom starting company draft if selected
        else if (newGameSettings['customStartingCompanyData'] &&
            newGameSettings['customStartingCompanyData']['talentOption'] === 'draft') {
            await createCustomCompanyDraft(mainUserCompany,
                newGameSettings['customStartingCompanyData']['draftSettings'])
        }
        else {
            // Add staff, facilities and goals. If running draft, add after ending draft
            for (let company of userControlledCompanies) {

                // Get main roster superstars
                let mainRoster = await getCompanyRosterByType(company, 'main');
                let mainRosterSuperstars = await getRosterSuperstars(mainRoster);

                // Add staff and facilities messages
                await addNewCompanyStaffAndFacilities(company, mainRosterSuperstars, indieAvailableRoster, game.settings);

                // Add unlimited artifacts message
                if (game.settings['unlock_all_items']) {
                    let newMessage = await createIntroducePowerupsSandboxModeMessage(company, game);
                    await addCompanyMessages(company, [newMessage]);
                }

                // Add sandbox mode message
                if (game.settings['sandbox_mode_enabled']) {
                    let newMessage = await createIntroduceSandboxModeMessage(0, 0, company.ownerName, game.settings);
                    await addCompanyMessages(company, [newMessage]);
                }

                // If custom starting company, add superstar joined / competitor messages
                if (newGameSettings['customStartingCompanyData']) {
                    let topSuperstars = [...mainRosterSuperstars].sort((a, b) => b.popularity - a.popularity).slice(0, 3);
                    let newMessage = await createJoinedCompanySuperstarMessage(getRandomChoice(topSuperstars),
                        game.monthCount, game.year);
                    await addCompanyMessages(company, [newMessage]);

                    let competitors = await getCpuControlledCompanies(company, game);
                    if (competitors.length) {
                        let newMessage = await createCustomStartingCompanyCompetitorMessage(getRandomChoice(competitors),
                            game.monthCount, game.year);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }

                // Add objectives
                if (!['mars', 'passion'].includes(company.storyName)) {
                    let objectives = await generateCompanyObjectives(company, game);
                    await addCompanyObjectives(company, objectives);
                }
            }
        }

        // Add sandbox mode options
        if (newGameSettings['gameModeOption'] === 'sandbox') {

            // Add high number of points
            for (let userControlledCompany of userControlledCompanies) {
                if (game.settings['unlimited_creative_points']) {
                    userControlledCompany.points = 1000000
                }
            }

            if (game.settings['all_indies_available']) {
                // Move all indie superstars and teams to indie available roster if not draft
                if (newGameSettings['mainRostersOption'] !== 'draft' &&
                    (!newGameSettings['customStartingCompanyData'] ||
                        newGameSettings['customStartingCompanyData']['talentOption'] !== 'draft')) {
                    let indieRosterSuperstars = await getRosterSuperstars(indieRoster);
                    let indieRosterTagTeams = await getRosterTagTeams(indieRoster);
                    await addRosterSuperstars(indieAvailableRoster, indieRosterSuperstars);
                    await addRosterTagTeams(indieAvailableRoster, indieRosterTagTeams);
                }
            }
        }
    }

    if (!newGameSettings) {
        if (gameDetails['yearlyRankings']) {
            await createGameYearlyRankings(gameDetails['yearlyRankings'], game);
        }

        // Add annual tournament companies
        await addAnnualTournamentOrganizationIds(gameCompanies);

        // Add segment consequence data
        for (const x of allSegments) {
            if (x.consequenceData) {
                addSegmentConsequenceData(x, allFactions, allChampionships, allBrands,
                    allFeuds, allSegments, allMatches, gameCompanies);
            }
        }

        // Add receiver companies to sent negotiations / trade offers
        for (const x of gameCompanies) {
            for (const y of (await getCompanySentNegotiations(x))) {
                if (y['receiverCompanyUid']) {
                    const c = gameCompanies.find(x => {
                        return x.uid === y['receiverCompanyUid'];
                    });
                    if (c) {
                        await addCompanyReceivedNegotiations(c, [y]);
                    }
                    delete y['receiverCompanyUid'];
                }
            }
            for (const y of (await getCompanySentTradeOffers(x))) {
                if (y['receiverCompanyUid']) {
                    const c = gameCompanies.find(x => {
                        return x.uid === y['receiverCompanyUid'];
                    });
                    if (c) {
                        await addCompanyReceivedTradeOffers(c, [y]);
                    }
                    delete y['receiverCompanyUid'];
                }
            }
        }
    }

    // Delete extra keys
    let collections = [Companies, Rosters, Factions, Brands, Feuds, TalentRequests, Tournaments, FeudItems, Events,
        MatchContracts, Streaks, Matches, GimmickMatches, SegmentItems, Messages, Superstars, TagTeams, Championships,
        ChampionshipReigns, Segments, Feuds];
    for (let collection of collections) {
        for (let object of collection.find({})) {
            delete object.uid;
            if (collection.name === 'Feuds') {
                delete object.feudItemUid;
            }
            if (collection.name === 'Segments') {
                delete object.segmentItemUid;
            }
            if (collection.name === 'Championships') {
                delete object.matchUid;
            }
            if (collection.name === 'Tournaments') {
                delete object.eventUid;
            }
            if (collection.name === 'Rosters') {
                delete object.originalSuperstarsUids;
            }
            if (collection.name === 'Superstars') {
                delete object.gimmicks;
            }
        }
    }

    // Developer mode settings
    if (globalUser.developerMode) {
        game.settings['run_annual_tournament'] = false;
        game.numberOfWeeklyShows = 0;
    }

    return game;
}

async function createGameFromScenarioData({scenarioData, gameSettings} = {}) {  // _get_new_game
    let data = {};
    try {
        let mainCompanyDetails = scenarioData.companies[0].companyDetails;

        // Disallow stories for free users
        if (mainCompanyDetails.storyName && mainCompanyDetails.storyName !== 'tutorial' &&
            !globalUser.paid) {
            data['error'] = 'story-mode-paid';
            return data;
        }

        // Disallow POW for trial users
        if (mainCompanyDetails.storyName === 'passion' && globalUser.freeTrialActivated) {
            data['error'] = 'pow-free-trial';
            return data;
        }

        // Disallow sandbox mode for free users
        if (gameSettings['gameModeOption'] === 'sandbox' && !globalUser.paid) {
            data['error'] = 'sandbox-mode-paid';
            return data;
        }

        // Disallow local multiplayer mode for free users
        if (gameSettings['playerModeOption'] === 'local-multiplayer' && !globalUser.paid) {
            data['error'] = 'local-multiplayer-mode-paid';
            return data;
        }

        // Disallow private games to be played except by creator
        let user = loadUser();
        if (scenarioData.scenarioDetails.private) {
            if ((user.uid !== scenarioData.scenarioDetails.creatorUid)) {
                data['error'] = 'private-scenario';
                return data;
            }
        }

        // Disallow custom starting company for free users
        if (gameSettings['customStartingCompanyData'] && !globalUser.paid) {
            data['error'] = 'custom-starting-company-paid';
            return data;
        }

        // Create game from scenario data
        data['createdGame'] = await createGameInDatabase(scenarioData, gameSettings);
        data['storyName'] = mainCompanyDetails.storyName;
    }
    catch (error) {
        captureError(error)
        data['error'] = true;
    }

    return data;
}

async function createScenarioFromScenarioData(scenarioData) {
    // Duplicates scenario and saves to database. Used in download scenario. todo test
    let scenarioDetails = scenarioData['scenarioDetails'];
    const scenario = {...Scenario(), ...scenarioDetails};
    Scenarios.insert(scenario);

    // Create game, add to scenario
    let gameData;
    ({ scenarioDetails, ...gameData } = scenarioData);
    const game = await createGame(gameData);
    await setScenarioGame(scenario, game);

    // Save
    db.saveDatabase();

    return scenario;
}

async function createGameCompanyWithRosters(companyData, newGameSettings, allBrandNames, draftAvailableSuperstars,
                                            draftAvailableTagTeams) {
    const companyDetails = companyData['companyDetails'];
    const company = {...Company(), ...companyDetails};
    if (newGameSettings) {
        const maxPoints = 5000;
        const minFans = 100;
        if (company.points > maxPoints && !newGameSettings['customStartingCompanyData']) {
            company.points = maxPoints
        }
        if (company.fans < minFans) {
            company.fans = minFans
        }
        company.overness += getRandomInt(-3, 5);
        if (company.overness >= 80) {
            company.hot = true
        }
        if (company.overness < 20) {
            company.stale = true
        }

        if (company.reputation === null) {
            company.reputation = 4;
            company.highestReputation = 4;
        }

        company.highestReputation = company.reputation;

        if (newGameSettings['selectedUserCompanies'] &&
            newGameSettings['selectedUserCompanies'].includes(company.name)) {
            company.userControlled = true;
        }
    }

    Companies.insert(company);

    // Create rosters
    await createCompanyRosters(companyData['rosters'], company, newGameSettings, allBrandNames, draftAvailableSuperstars,
        draftAvailableTagTeams);

    return company;
}

async function createGameCompanyOtherObjects(company, companyData, allFactions, allFeuds, allBrands, allRosters,
                                             startingEventIndex, newGameSettings, game, favoritedCommunitySegments,
                                             storyName) {

    if (!newGameSettings) {
        await createCompanyStaff(companyData['staff'], company);
    }

    let companyTournaments = [];
    if (!newGameSettings) {
        await createCompanyTournaments(companyData['tournaments'], company);
        companyTournaments = await getCompanyTournaments(company);
    }

    // Create championships
    let companyMainRoster = await getCompanyRosterByType(company, 'main');
    let companyBrandNames = (await getRosterBrands(companyMainRoster)).map(x => x.name);
    await createCompanyChampionships(companyData['championships'], companyTournaments, company,
        newGameSettings, companyBrandNames);
    let companyChampionships = await getCompanyChampionships(company);

    // Create gimmick matches
    await createCompanyGimmickMatches(companyData['gimmickMatches'], company, game, newGameSettings);

    // Create events
    let allEvents = await createCompanyEvents(companyData['events'], companyChampionships,
        companyTournaments, allFeuds, company, newGameSettings,
        companyBrandNames, startingEventIndex);

    // Get all segments
    let allSegments = await Promise.all(
        allEvents.map(x => {
            return getEventSegments(x)
        })
    );
    allSegments = allSegments.flat();

    // Get all matches
    let allMatches = await Promise.all(
        allEvents.map(x => {
            return getEventMatches(x)
        })
    );
    allMatches = allMatches.flat();

    // Recreate company objects if importing
    if (!newGameSettings) {
        await createCompanyAlerts(companyData['companyAlerts'], company);
        await createCompanyFacilities(companyData['facilities'], company);
        await createCompanyLogs(companyData['companyLogs'], company);
        await createCompanyMessages(companyData['messages'], company);
        const companyMessages = await getCompanyMessages(company);
        await createCompanyObjectives(companyData['objectives'], company);
        await createCompanyRelationships(companyData['relationships'], company);
        await createCompanyRandomEvents(companyData['randomEvents'], companyMessages, company);
        await createCompanySentNegotiations(companyData['sentNegotiations'], company);
        await createCompanySentTradeOffers(companyData['sentTradeOffers'], company);
        await createCompanyTalentRequests(companyData['talentRequests'], allFactions, allBrands, company);
        if (companyData['news']) {
            await createCompanyNews(companyData['news'], company);
        }
        if (companyData['storyChoices']) {
            await createCompanyStoryChoices(companyData['storyChoices'], company);
        }
        await createCompanyPowerups(companyData['powerups'], company);
        await createCompanyFeudItems(companyData['feudItems'], allFeuds, company);
        await createCompanySegmentItems(companyData['segmentItems'], allSegments, company);
        if (companyData['draft']) {
            await createCompanyDraft(companyData['draft'], allRosters, company);
        }

        // Add staff task data uids
        const companyStaffMembers = await getCompanyStaff(company);
        for (const staffMember of companyStaffMembers) {
            if (staffMember.taskData && staffMember.taskData['segment_id']) {
                let taskDataSegment = allSegments.find(x => {
                    return x.uid === staffMember.taskData['segment_id'];
                });
                if (taskDataSegment) {
                    staffMember.taskData['segment_id'] = taskDataSegment.$loki;
                }
                else {
                    console.log('object not found for staff task data', staffMember.taskData)
                    delete staffMember.taskData['segment_id']
                }
            }
            if (staffMember.taskData && staffMember.taskData['talent_id']) {
                let taskDataTalent = Superstars.findOne({
                    'uid': staffMember.taskData['talent_id']
                });
                if (taskDataTalent) {
                    staffMember.taskData['talent_id'] = taskDataTalent.$loki;
                }
                else {
                    console.log('object not found for staff task data', staffMember.taskData)
                    delete staffMember.taskData['talent_id']
                }
            }
        }
    }

    // Add new company objects for new game
    if (newGameSettings) {

        // Add feud items
        for (let x of standardFeudItemsData) {
            let newFeudItem = {...FeudItem(), ...JSON.parse(JSON.stringify(x))};

            if (company.userControlled && game.settings['unlock_all_items']) {
                newFeudItem.unlocked = true;
            }

            await FeudItems.insert(newFeudItem);
            await addCompanyFeudItems(company, [newFeudItem]);
        }

        // Add segment items
        for (let x of standardSegmentItemsData) {
            let newSegmentItem = {...SegmentItem(), ...JSON.parse(JSON.stringify(x))};

            if (company.userControlled && game.settings['unlock_all_items']) {
                newSegmentItem.unlocked = true;
            }

            await SegmentItems.insert(newSegmentItem);
            await addCompanySegmentItems(company, [newSegmentItem]);
        }

        // Get powerups (except story ones)
        let powerupsData = standardPowerupsData.filter(x => !x.storyName);

        // Add user (story) powerups if unlocked
        const user = loadUser();
        if (user && globalUser.paid && storyName !== 'passion' && company.userControlled) {
            powerupsData.push(...standardPowerupsData.filter(x => user.unlockedPowerups.includes(x.name)))
        }

        // Remove competition based powerups if no competition
        if (!game.competitorsPresent) {
            powerupsData = powerupsData.filter(x => x.effect !== 'superstar_jump')
        }

        // Remove some powerups for competitors
        if (!company.userControlled) {
            powerupsData = filterCompetitorPowerups(powerupsData);
        }

        // Remove Hypnosis, Step Up and brand powerups in POW
        if (storyName === 'passion') {
            powerupsData = powerupsData.filter(x => !['reroll_goal', 'one_match', 'allow_other_brands',
                'allow_other_brands_extended'].includes(x.effect))
        }

        // Add powerups
        for (let x of powerupsData) {
            let newPowerup = {...Powerup(), ...JSON.parse(JSON.stringify(x))};

            if (company.userControlled && game.settings['unlock_all_items']) {
                newPowerup.unlocked = true;
                newPowerup.stock = 99;
            }

            await Powerups.insert(newPowerup);
            await addCompanyPowerups(company, [newPowerup]);
        }

        // Add femme fatale if POW completed
        if (user && globalUser.paid && user.storiesCompleted.includes('passion') &&
            !storyName && company.userControlled) {
            const femmeFataleMatch = createFemmeFataleMatch();
            await GimmickMatches.insert(femmeFataleMatch);
            await addCompanyGimmickMatches(company, [femmeFataleMatch]);
        }

        // Get community segments favorited by user and not present in standard segments
        if (user && globalUser.paid && company.userControlled &&
            user.settings['loadFavoriteCommunitySegments'] !== false && favoritedCommunitySegments) {
            const standardSegmentItemsNames = standardSegmentItemsData.map(x => x.name);
            const communitySegmentsToAdd = favoritedCommunitySegments
                .filter(x => !standardSegmentItemsNames.includes(x.name));
            for (let communitySegmentToAdd of communitySegmentsToAdd) {
                let newSegmentItem = {...SegmentItem(), ...JSON.parse(JSON.stringify(communitySegmentToAdd))};
                await SegmentItems.insert(newSegmentItem);
                newSegmentItem.hypeBoost = newSegmentItem.feudOnly ? 1 : 0;
                newSegmentItem.popularityBoost = newSegmentItem.feudOnly ? 0 : 1;
                newSegmentItem.difficulty = 1;
                newSegmentItem.entertainment = 2;
                newSegmentItem.action = 1;
                newSegmentItem.custom = true;
                await addCompanySegmentItems(company, [newSegmentItem]);
            }
        }
    }

    return [allSegments, allMatches, companyChampionships];
}

async function getRosterObjects(companies) {
    // Get superstars and tagteams from all rosters
    let allRosters = await Promise.all(
        companies.map(x => {
            return getCompanyRosters(x)
        })
    );
    allRosters = allRosters.flat();
    let allFactions = await Promise.all(
        allRosters.map(x => {
            return getRosterFactions(x)
        })
    );
    allFactions = allFactions.flat();
    let allFeuds = await Promise.all(
        allRosters.map(x => {
            return getRosterFeuds(x)
        })
    );
    allFeuds = allFeuds.flat();
    let allBrands = await Promise.all(
        allRosters.map(x => {
            return getRosterBrands(x)
        })
    );
    allBrands = allBrands.flat();
    return [allRosters, allFactions, allFeuds, allBrands];
}

async function createCompanyRosters(rostersData, company, newGameSettings, allBrandNames, draftAvailableSuperstars,
                                    draftAvailableTagTeams) {
    let companyRosters = [];
    for (let i = 0; i < rostersData.length; i++) {
        const rosterData = rostersData[i];
        const roster = await createCompanyRoster(rosterData, rosterData['type'], newGameSettings, allBrandNames,
            draftAvailableSuperstars, draftAvailableTagTeams);
        companyRosters.push(roster);
    }
    await addCompanyRosters(company, companyRosters);
}

async function createCompanyRoster(rosterData, rosterType, newGameSettings, allBrandNames, draftAvailableSuperstars,
                                   draftAvailableTagTeams) {
    const roster = Roster(rosterType);
    roster['uid'] = rosterData['uid'];
    roster['originalSuperstarsUids'] = rosterData['originalSuperstarsUids'];
    Rosters.insert(roster);

    if (!newGameSettings) {
        // Create staff
        await createRosterStaff(rosterData['staff'], roster);
    }

    // Create brands
    let companyBrandNames = [];
    if (globalUser.paid) {
        await createRosterBrands(rosterData['brands'], roster, newGameSettings, companyBrandNames, allBrandNames);
    }

    // Create superstars
    let rosterSuperstars = await createRosterSuperstars(rosterData['superstars'], roster, newGameSettings,
        companyBrandNames);

    // Add superstars for draft
    if (newGameSettings && newGameSettings['mainRostersOption'] === 'draft') {
        if (roster.type === 'main' ||
            (roster.type === 'training' && newGameSettings['draftIncludeTraining']) ||
            (roster.type === 'indie' && newGameSettings['draftIncludeIndies'])) {
            draftAvailableSuperstars.push(...rosterSuperstars)
        }
    }

    // Create tagTeams
    await createRosterTagTeams(rosterData['tagTeams'], roster);
    const rosterTagTeams = await getRosterTagTeams(roster);

    // Add tagTeams for draft
    if (newGameSettings && newGameSettings['mainRostersOption'] === 'draft') {
        if (roster.type === 'main' ||
            (roster.type === 'training' && newGameSettings['draftIncludeTraining']) ||
            (roster.type === 'indie' && newGameSettings['draftIncludeIndies'])) {
            draftAvailableTagTeams.push(...rosterTagTeams)
        }
    }

    // Create factions
    if ((!newGameSettings || newGameSettings['mainRostersOption'] !== 'draft') && globalUser.paid) {
        await createRosterFactions(rosterData['factions'], roster);
    }

    if (!newGameSettings) {
        // Create feuds
        await createRosterFeuds(rosterData['feuds'], roster);
    }

    return roster;
}

async function createRosterSuperstars(superstarsData, roster, newGameSettings, companyBrandNames) {
    let rosterSuperstars = [];
    for (let i = 0; i < superstarsData.length; i++) {
        const superstarData = superstarsData[i];
        const superstar = {...Superstar(), ...superstarData};
        Superstars.insert(superstar);
        if (!globalUser.paid || !companyBrandNames.includes(superstar.brandName)) {
            superstar.brandName = null;
        }
        superstar.pronoun = getRosterMemberPronoun(superstar);
        superstar.possessivePronoun = getRosterMemberPronoun(superstar, 'possessive');
        superstar.objectivePronoun = getRosterMemberPronoun(superstar, 'objective');

        if (newGameSettings) {
            superstar.overness += getRandomInt(-3, 5);
            if (superstar.overness >= 80) {
                superstar.hot = true
            }
            if (superstar.overness < 20) {
                superstar.stale = true
            }

            // Don't allow part timer and retired at the same time
            if (superstar.partTimer && superstar.retired) {
                superstar.partTimer = false;
            }

            // Add part timer's appearances
            if (superstar.partTimer) {
                superstar.appearances = getPartTimerAppearances(superstar);
            }

            // Add default injury names
            if (superstar.injured) {
                if (superstar.injured > 6) {
                    superstar.injuryName = 'major injury'
                }
                else {
                    superstar.injuryName = 'minor injury'
                }
            }

            if (superstar.monthToAppearIn > 2) {
                superstar.monthToAppearIn += getRandomInt(-2, 2);
            }

            superstar.highestRank = getRankFromPopularity(superstar.popularity);
        }

        // Create gimmicks
        if (superstarData['gimmicks']) {
            await createSuperstarGimmicks(superstarData['gimmicks'], superstar, roster, newGameSettings);
        }

        // Add staff object if present
        if (superstar.staffObjectData) {
            const superstarStaffObject = {...Staff(), ...superstar.staffObjectData};
            StaffMembers.insert(superstarStaffObject);
            setStaffSuperstarObject(superstarStaffObject, superstar);
            delete superstar.staffObjectData;
        }

        rosterSuperstars.push(superstar);
    }
    addRosterSuperstars(roster, rosterSuperstars);

    return rosterSuperstars;
}

async function createSuperstarGimmicks(gimmicksData, superstar, roster, newGameSettings) {
    let gimmicks = [];
    for (let i = 0; i < gimmicksData.length; i++) {
        const gimmickData = gimmicksData[i];
        const gimmick = {...Gimmick(), ...gimmickData};
        Gimmicks.insert(gimmick);
        gimmicks.push(gimmick);

        if (newGameSettings) {
            gimmick.startMonth = 0;
            gimmick.startYear = 0;
        }

        // Add relationships
        if (gimmick['rosterUid']) {
            const gimmickRoster = [roster].find(x => {
                return x.uid === gimmick.rosterUid;
            });
            if (gimmickRoster) {
                await addRosterGimmicks(gimmickRoster, [gimmick]);
            }
            delete gimmick.rosterUid;
        }
    }
    addSuperstarGimmicks(superstar, gimmicks);
}

async function createRosterTagTeams(tagTeamsData, roster) {
    let rosterTagTeams = [];
    for (let i = 0; i < tagTeamsData.length; i++) {
        const tagTeamData = tagTeamsData[i];
        const tagTeam = {...TagTeam(), ...tagTeamData};
        TagTeams.insert(tagTeam);
        if (!tagTeamData['detachedItem']) {
            rosterTagTeams.push(tagTeam);
        }
    }
    await addRosterTagTeams(roster, rosterTagTeams);
}

async function createRosterFactions(factionsData, roster) {
    let rosterFactions = [];
    for (let i = 0; i < factionsData.length; i++) {
        const factionData = factionsData[i];
        const faction = {...Faction(), ...factionData};
        Factions.insert(faction);
        rosterFactions.push(faction);
    }

    await addRosterFactions(roster, rosterFactions);
}

async function createRosterBrands(brandsData, roster, newGameSettings, companyBrandNames, allBrandNames) {
    let rosterBrands = [];
    for (let i = 0; i < brandsData.length; i++) {
        const brandData = brandsData[i];
        if (!allBrandNames.includes(brandData['name'])) {
            const brand = {...Brand(), ...brandData};
            Brands.insert(brand);
            rosterBrands.push(brand);
            companyBrandNames.push(brand.name);
            allBrandNames.push(brand.name);

            if (newGameSettings) {
                brand.overness += getRandomInt(-3, 5);
                if (brand.overness >= 80) {
                    brand.hot = true
                }
                if (brand.overness < 20) {
                    brand.stale = true
                }
            }
        }
    }

    await addRosterBrands(roster, rosterBrands);

    return rosterBrands;
}

async function createRosterFeuds(feudsData, roster) {
    let rosterFeuds = [];
    for (let i = 0; i < feudsData.length; i++) {
        const feudData = feudsData[i];
        const feud = {...Feud(), ...feudData};
        Feuds.insert(feud);
        rosterFeuds.push(feud);
    }
    await addRosterFeuds(roster, rosterFeuds);
}

async function createCompanyChampionships(championshipsData, companyTournaments, company,
                                          newGameSettings, companyBrandNames) {
    let companyChampionships = [];
    for (let i = 0; i < championshipsData.length; i++) {
        const championshipData = championshipsData[i];
        const championship = {...Championship(), ...championshipData};
        if (!globalUser.paid || !companyBrandNames.includes(championship.brandName)) {
            championship.brandName = null;
        }
        Championships.insert(championship);
        if (newGameSettings) {
            // Add xp over prestige base value
            if (championship.prestige !== 'C') {
                championship.xp += 10
            }
        }
        if (!championship['detachedItem']) {
            companyChampionships.push(championship);
        }

        // Add to superstar
        if (championship.superstarUid && (!newGameSettings || newGameSettings['mainRostersOption'] !== 'draft')) {
            const championSuperstar = Superstars.findOne({
                'uid': championship.superstarUid
            });
            if (championSuperstar) {
                addSuperstarChampionships(championSuperstar, [championship]);

                if (newGameSettings) {
                    // Add reign
                    const championshipReign = ChampionshipReign(0, 0);
                    ChampionshipReigns.insert(championshipReign);
                    await addSuperstarChampionshipReigns(championSuperstar, [championshipReign]);
                    await addChampionshipChampionshipReigns(championship, [championshipReign]);
                    if (championship.tagTeam || championship.trio) {
                        let championTagTeams = (await getSuperstarTagTeams(championSuperstar))
                            .filter(x => x.trio === championship.trio);
                        if (championTagTeams.length) {
                            championshipReign.holderName = championTagTeams[0].name;
                        }
                    }
                    else {
                        championshipReign.holderName = championSuperstar.name;
                    }
                }
            }
            else {
                championship.vacated = true;
                console.log('champion not found when creating game', championship.name, championship.superstarUid)
            }
            delete championship.superstarUid;
        }
        else {
            championship.vacated = true;
        }

        // Add championship reigns
        if (!newGameSettings) {
            await createCompanyChampionshipReigns(championshipData['reigns'], championship);
        }

        // Add tournament
        if (championship['tournamentUid']) {
            const championshipTournament = companyTournaments.find(x => {
                return x.uid === championship.tournamentUid;
            });
            if (championshipTournament) {
                await addTournamentChampionships(championshipTournament, [championship]);
            }
            else {
                console.log('tournament not found when creating game', championship.name, championship.tournamentUid)
            }
            delete championship.tournamentUid;
        }

        delete championshipsData['reigns'];
    }
    await addCompanyChampionships(company, companyChampionships);
}

async function createCompanyEvents(eventsData, companyChampionships, companyTournaments,
                                   allFeuds, company, newGameSettings, companyBrandNames, startingEventIndex) {
    let allEvents = [];
    let companyEvents = [];
    await asyncFor(eventsData, async (eventData) => {
        const event = await createCompanyEvent(eventData, companyEvents, companyChampionships, companyTournaments,
            allFeuds, companyBrandNames, newGameSettings);
        if (!event['detachedEvent']) {
            companyEvents.push(event)
        }
        allEvents.push(event);
    });
    await addCompanyEvents(company, companyEvents);

    if (newGameSettings) {
        // Add starting event
        const parentEvent = companyEvents[startingEventIndex];
        const latestEvent = Event(parentEvent.name);
        await Events.insert(latestEvent);
        await addCompanyEvents(company, [latestEvent]);
        const isTopEvent = parentEvent.name === getArrayMaxByProperty(companyEvents, 'xp').name;
        latestEvent.year = company.realYear;
        latestEvent.prestige = parentEvent.prestige;
        latestEvent.hype = await getEventHype(latestEvent, isTopEvent);
        if (globalUser.paid) {
            latestEvent.brandName = parentEvent.brandName
        }
        addChildEvent(parentEvent, latestEvent);
    }

    return allEvents;
}

async function createCompanyEvent(eventData, companyEvents, companyChampionships, companyTournaments, allFeuds,
                                  companyBrandNames, newGameSettings) {
    const event = {...Event(), ...eventData};
    if (!globalUser.paid || !companyBrandNames.includes(event.brandName)) {
        event.brandName = null;
    }
    Events.insert(event);

    // Add parent event
    if (event.parentUid) {
        const parentEvent = companyEvents.find(x => {
            return x.uid === event.parentUid;
        });
        addChildEvent(parentEvent, event);
        delete event.parentUid;
    }

    // Add tournaments
    if (!newGameSettings) {
        const eventTournaments = companyTournaments.filter(x => {
            return x['eventUid'] === eventData['uid'];
        });
        if (eventTournaments.length > 0) {
            await addEventTournaments(event, eventTournaments);
        }
    }

    // Create matches
    await createEventMatches(eventData, companyChampionships, companyTournaments, allFeuds, event);

    // Create segments
    await createEventSegments(eventData, companyChampionships, allFeuds, event);

    // Create match contracts
    await createEventMatchContracts(eventData, companyChampionships, companyTournaments,
        event, newGameSettings);

    // Create streaks
    await createEventStreaks(eventData, event);

    delete event.matches;
    delete event.segments;
    delete event.matchContracts;
    delete event.streaks;

    return event;
}

async function createEventMatches(eventData, companyChampionships, companyTournaments,
                                  allFeuds, event) {
    let eventMatches = [];
    if (eventData['matches']) {
        for (let i = 0; i < eventData['matches'].length; i++) {
            const matchData = eventData['matches'][i];
            const match = await createEventMatch(matchData, companyChampionships,
                companyTournaments, allFeuds);
            eventMatches.push(match)
        }
    }
    await addEventMatches(event, eventMatches);
}

async function createEventMatch(matchData, companyChampionships, companyTournaments, allFeuds) {
    let match = {...Match(), ...matchData};
    Matches.insert(match);

    // Get participants
    let matchParticipants;
    if (match.type === 'singles') {
        matchParticipants = Superstars.find({'uid': {'$in': match.participantUids}});
        matchParticipants.sort((a, b) => match.participantUids.indexOf(a.uid) - match.participantUids.indexOf(b.uid));
        await addMatchSuperstars(match, matchParticipants);
    }
    else {
        matchParticipants = TagTeams.find({'uid': {'$in': match.participantUids}});
        matchParticipants.sort((a, b) => match.participantUids.indexOf(a.uid) - match.participantUids.indexOf(b.uid));
        await addMatchTagTeams(match, matchParticipants);
    }
    if (matchParticipants.length !== match.participantUids.length) {
        console.log('match participants not found when creating match', match)
    }

    // Add championships
    const matchChampionships = companyChampionships.filter(x => {
        return x['matchUid'] === matchData['uid']
    });
    await addMatchChampionships(match, matchChampionships);

    // Add tournament
    if (match['tournamentUid']) {
        const matchTournament = companyTournaments.find(x => {
            return x.uid === match.tournamentUid;
        });
        if (matchTournament) {
            await addTournamentMatches(matchTournament, [match]);
        }
        else {
            console.log('tournament not found when creating match', match, match.tournamentUid)
        }
        delete match.tournamentUid;
    }

    // Add gimmick match
    if (match['gimmickMatchUid']) {
        const matchGimmickMatch = GimmickMatches.findOne({
            'uid': match.gimmickMatchUid
        });
        if (matchGimmickMatch) {
            await addGimmickMatchMatches(matchGimmickMatch, [match]);
        }
        else {
            console.log('gimmick match not found when creating match', match, match.gimmickMatchUid)
        }
        delete match.gimmickMatchUid;
    }

    // Add feuds
    if (match['feudUids'].length > 0) {
        const matchFeuds = allFeuds.filter(x => {
            return match['feudUids'].indexOf(x.uid) >= 0;
        });
        if (matchFeuds.length > 0) {
            await addMatchFeuds(match, matchFeuds);
        }
        if (match['feudUids'].length !== matchFeuds.length) {
            console.log('feud not found when creating match', match, match.feudUids)
        }
    }
    delete match.feudUids;

    // Add championship reigns
    if (match['championshipReignUids'].length > 0) {
        const matchChampionshipReigns = ChampionshipReigns.find({'uid': {'$in': match['championshipReignUids']}});
        if (matchChampionshipReigns.length > 0) {
            await addMatchChampionshipReigns(match, matchChampionshipReigns);
        }
        if (match['championshipReignUids'].length !== matchChampionshipReigns.length) {
            console.log('reign not found when creating match', match, match.championshipReignUids)
        }
    }
    delete match.championshipReignUids;

    // Add referee uid
    if (match['refereeUid']) {
        const refereeSuperstar = Superstars.findOne({
            'uid': match.refereeUid
        });
        if (refereeSuperstar) {
            match['refereeId'] = refereeSuperstar.$loki;
        }
        delete match.refereeUid;
    }

    // Add managers used ids
    if (match['managersUsedUids']) {
        for (const uid in match['managersUsedUids']) {
            if (match['managersUsedUids'].hasOwnProperty(uid)) {
                let key = Superstars.findOne({
                    'uid': uid
                })?.$loki;
                let value = Superstars.findOne({
                    'uid': match['managersUsedUids'][uid]
                })?.$loki;
                if (key && value) {
                    match['managersUsed'][key] = value
                }
            }
        }
        delete match.managersUsedUids;
    }

    // Remove match's uid keys
    delete match.participantUids;

    return match;
}

async function createEventSegments(eventData, companyChampionships, allFeuds, event) {
    let eventSegments = [];
    if (eventData['segments']) {
        for (let i = 0; i < eventData['segments'].length; i++) {
            const segmentData = eventData['segments'][i];
            const segment = await createEventSegment(segmentData, companyChampionships, allFeuds);
            eventSegments.push(segment);
        }
    }
    await addEventSegments(event, eventSegments);
}

async function createEventSegment(segmentData, companyChampionships, allFeuds) {
    let segment = {...Segment(), ...segmentData};
    Segments.insert(segment);

    // Get participants
    let segmentParticipants = Superstars.find({}).concat(TagTeams.find({})).filter(x => {
        return segment.participantUids.indexOf(x.uid) >= 0
    });
    if (segmentParticipants.length !== segment.participantUids.length) {
        console.log('segment participants not found when creating segment', segment)
    }
    segmentParticipants.sort((a, b) => segment.participantUids.indexOf(b.uid) - segment.participantUids.indexOf(a.uid));
    for (const p of segmentParticipants) {
        if (p.objectName === 'superstar') {
            await addSegmentSuperstars(segment, [p]);
        }
        else {
            await addSegmentTagTeams(segment, [p]);
        }
    }

    // Add feuds
    if (segment['feudUids'].length > 0) {
        const segmentFeuds = allFeuds.filter(x => {
            return segment['feudUids'].indexOf(x.uid) >= 0;
        });
        if (segmentFeuds.length > 0) {
            await addSegmentFeuds(segment, segmentFeuds);
        }
        if (segment['feudUids'].length !== segmentFeuds.length) {
            console.log('feud not found when creating segment', segment, segment.feudUids)
        }
    }
    delete segment.feudUids;

    // Add managers used ids
    if (segment['managersUsedUids']) {
        for (const uid in segment['managersUsedUids']) {
            if (segment['managersUsedUids'].hasOwnProperty(uid)) {
                let key = Superstars.findOne({
                    'uid': uid
                })?.$loki;
                let value = Superstars.findOne({
                    'uid': segment['managersUsedUids'][uid]
                })?.$loki;
                if (key && value) {
                    segment['managersUsed'][key] = value
                }
            }
        }
        delete segment.managersUsedUids;
    }

    delete segment.participantUids;

    return segment;
}

async function createCompanyAlerts(companyAlertsData, company) {
    let companyAlerts = [];
    for (let i = 0; i < companyAlertsData.length; i++) {
        const companyAlertData = companyAlertsData[i];
        const companyAlert = {...CompanyAlert(), ...companyAlertData};
        CompanyAlerts.insert(companyAlert);
        companyAlerts.push(companyAlert);
    }
    await addCompanyCompanyAlerts(company, companyAlerts);
}

async function createCompanyLogs(companyLogsData, company) {
    let companyLogs = [];
    for (let i = 0; i < companyLogsData.length; i++) {
        const companyLogData = companyLogsData[i];
        const companyLog = {...CompanyLog(), ...companyLogData};
        CompanyLogs.insert(companyLog);
        companyLogs.push(companyLog);
    }
    await addCompanyCompanyLogs(company, companyLogs);
}

async function createCompanyGimmickMatches(companyGimmickMatchesData, company, game, newGameSettings) {
    let companyGimmickMatches = [];
    let unavailable = ['Brawl', 'Loser Leaves', 'Steel Cell', 'Hell In A Cell', 'Flag', 'Ambulance',
        'LMS', 'TLC', 'Unsanctioned', 'Tables', 'Casket'];
    let companyGimmickMatchNames = companyGimmickMatchesData.map(x => x.name);

    for (let i = 0; i < companyGimmickMatchesData.length; i++) {
        const companyGimmickMatchData = companyGimmickMatchesData[i];
        const companyGimmickMatch = {...GimmickMatch(), ...companyGimmickMatchData};

        if (newGameSettings && company.userControlled) {
            // Make specific gimmick matches unavailable
            if (unavailable.includes(companyGimmickMatch.name)) {
                if (companyGimmickMatchNames.includes(getGimmickMatchUnlockedBy(companyGimmickMatch.name))) {
                    companyGimmickMatch.available = false;
                }
            }

            if (game.settings['unlock_all_items']) {
                companyGimmickMatch.available = true;
            }
        }

        GimmickMatches.insert(companyGimmickMatch);
        if (!companyGimmickMatch['detachedItem']) {
            companyGimmickMatches.push(companyGimmickMatch);
        }
    }
    await addCompanyGimmickMatches(company, companyGimmickMatches);
}

function getGimmickMatchUnlockedBy(gimmickMatchName) {  // get_gimmick_match_unlocked_by
    for (const [k, v] of Object.entries(gimmickMatchUnlocksData)) {
        if (v.includes(gimmickMatchName)) {
            return k;
        }
    }
    return null;
}

async function createCompanyRelationships(companyRelationshipsData, company) {
    let companyRelationships = [];
    for (let i = 0; i < companyRelationshipsData.length; i++) {
        const companyRelationshipData = companyRelationshipsData[i];
        const companyRelationship = {...Relationship(), ...companyRelationshipData};
        Relationships.insert(companyRelationship);
        companyRelationships.push(companyRelationship);

        if (companyRelationship['superstarUid']) {
            const companyRelationshipSuperstar = Superstars.findOne({
                'uid': companyRelationship['superstarUid']
            });
            if (companyRelationshipSuperstar) {
                await addSuperstarRelationships(companyRelationshipSuperstar, [companyRelationship]);
            }
            delete companyRelationship.superstarUid;
        }
    }
    await addCompanyRelationships(company, companyRelationships);
}

async function createCompanyRandomEvents(companyRandomEventsData, companyMessages, company) {
    let companyRandomEvents = [];
    for (let i = 0; i < companyRandomEventsData.length; i++) {
        const companyRandomEventData = companyRandomEventsData[i];
        const companyRandomEvent = {...RandomEvent(), ...companyRandomEventData};
        RandomEvents.insert(companyRandomEvent);
        companyRandomEvents.push(companyRandomEvent);

        if (companyRandomEvent['superstarUid']) {
            const randomEventSuperstar = Superstars.findOne({
                'uid': companyRandomEvent['superstarUid']
            });
            if (randomEventSuperstar) {
                await addSuperstarRandomEvents(randomEventSuperstar, [companyRandomEvent]);
            }
            else {
                console.log('superstar not found when creating randomEvent', companyRandomEvent.name, companyRandomEvent.superstarUid)
            }
            delete companyRandomEvent.superstarUid;
        }

        if (companyRandomEvent['messageUid']) {
            const randomEventMessage = Messages.findOne({
                'uid': companyRandomEvent.messageUid
            });
            if (randomEventMessage) {
                await addRandomEventMessages(companyRandomEvent, [randomEventMessage]);
            }
            else {
                console.log('message not found when creating randomEvent', companyRandomEvent.name, companyRandomEvent.messageUid)
            }
            delete companyRandomEvent.messageUid;
        }

        if (companyRandomEvent['championshipUid']) {
            const randomEventChampionship = Championships.findOne({
                'uid': companyRandomEvent.championshipUid
            });
            if (randomEventChampionship) {
                await addChampionshipRandomEvents(randomEventChampionship, [companyRandomEvent]);
            }
            else {
                console.log('championship not found when creating randomEvent', companyRandomEvent.name, companyRandomEvent.championshipUid)
            }
            delete companyRandomEvent.championshipUid;
        }

        if (companyRandomEvent['gimmickMatchUid']) {
            const randomEventGimmickMatch = GimmickMatches.findOne({
                'uid': companyRandomEvent.gimmickMatchUid
            });
            if (randomEventGimmickMatch) {
                await addGimmickMatchRandomEvents(randomEventGimmickMatch, [companyRandomEvent]);
            }
            else {
                console.log('gimmickMatch not found when creating randomEvent', companyRandomEvent.name, companyRandomEvent.gimmickMatchUid)
            }
            delete companyRandomEvent.gimmickMatchUid;
        }

        if (companyRandomEvent['selectionIds'].length > 0) {
            const selectedSuperstars = companyRandomEvent['selectionIds'].map(x => {
                return Superstars.findOne({uid: x});
            }).filter(x => x);
            companyRandomEvent.selectionIds = selectedSuperstars.map(x => x.$loki);
        }

    }
    await addCompanyRandomEvents(company, companyRandomEvents);
}

async function createCompanySentNegotiations(companySentNegotiationsData, company) {
    let companySentNegotiations = [];
    for (let i = 0; i < companySentNegotiationsData.length; i++) {
        const companySentNegotiationData = companySentNegotiationsData[i];
        const companySentNegotiation = {...Negotiation(), ...companySentNegotiationData};
        Negotiations.insert(companySentNegotiation);
        companySentNegotiations.push(companySentNegotiation);

        if (companySentNegotiation['superstarUid']) {
            const companySentNegotiationSuperstar = Superstars.findOne({
                'uid': companySentNegotiation['superstarUid']
            });
            if (companySentNegotiationSuperstar) {
                await addSuperstarNegotiations(companySentNegotiationSuperstar, [companySentNegotiation]);
            }
            else {
                console.log('superstar not found when creating companySentNegotiation', companySentNegotiation.name, companySentNegotiation.superstarUid)
            }
            delete companySentNegotiation.superstarUid;
        }

        if (companySentNegotiation['tagTeamUid']) {
            const companySentNegotiationTagTeam = TagTeams.findOne({
                'uid': companySentNegotiation.tagTeamUid
            });
            if (companySentNegotiationTagTeam) {
                await addTagTeamNegotiations(companySentNegotiationTagTeam, [companySentNegotiation]);
            }
            else {
                console.log('tagTeam not found when creating companySentNegotiation', companySentNegotiation.name, companySentNegotiation.tagTeamUid)
            }
            delete companySentNegotiation.tagTeamUid;
        }
    }
    await addCompanySentNegotiations(company, companySentNegotiations);
}

async function createCompanySentTradeOffers(companySentTradeOffersData, company) {
    let companySentTradeOffers = [];
    for (let i = 0; i < companySentTradeOffersData.length; i++) {
        const companySentTradeOfferData = companySentTradeOffersData[i];
        const companySentTradeOffer = {...TradeOffer(), ...companySentTradeOfferData};
        TradeOffers.insert(companySentTradeOffer);
        companySentTradeOffers.push(companySentTradeOffer);

        // Add superstars
        if (companySentTradeOffer['offeredSuperstarsUids'].length > 0) {
            const offeredSuperstars = Superstars.find({'uid': {'$in': companySentTradeOffer['offeredSuperstarsUids']}});
            if (offeredSuperstars.length > 0) {
                await addTradeOfferOfferedSuperstars(companySentTradeOffer, offeredSuperstars);
            }
            if (companySentTradeOffer['offeredSuperstarsUids'].length !== offeredSuperstars.length) {
                console.log('offeredSuperstars not found when creating sent trade offer', companySentTradeOffer,
                    companySentTradeOffer.offeredSuperstarsUids)
            }
        }
        delete companySentTradeOffer.offeredSuperstarsUids;
        if (companySentTradeOffer['requestedSuperstarsUids'].length > 0) {
            const requestedSuperstars = Superstars.find({'uid': {'$in': companySentTradeOffer['requestedSuperstarsUids']}});
            if (requestedSuperstars.length > 0) {
                await addTradeOfferRequestedSuperstars(companySentTradeOffer, requestedSuperstars);
            }
            if (companySentTradeOffer['requestedSuperstarsUids'].length !== requestedSuperstars.length) {
                console.log('requestedSuperstars not found when creating sent trade offer', companySentTradeOffer,
                    companySentTradeOffer.requestedSuperstarsUids)
            }
        }
        delete companySentTradeOffer.requestedSuperstarsUids;
    }
    await addCompanySentTradeOffers(company, companySentTradeOffers);
}

async function createCompanyTalentRequests(companyTalentRequestsData, allFactions, allBrands, company) {
    let companyTalentRequests = [];
    for (let i = 0; i < companyTalentRequestsData.length; i++) {
        const companyTalentRequestData = companyTalentRequestsData[i];
        const companyTalentRequest = {...TalentRequest(), ...companyTalentRequestData};
        TalentRequests.insert(companyTalentRequest);
        companyTalentRequests.push(companyTalentRequest);

        if (companyTalentRequest['superstarUid']) {
            const companyTalentRequestSuperstar = Superstars.findOne({
                'uid': companyTalentRequest['superstarUid']
            });
            if (companyTalentRequestSuperstar) {
                await addSuperstarTalentRequests(companyTalentRequestSuperstar, [companyTalentRequest]);
            }
            else {
                console.log('superstar not found when creating companyTalentRequestData', companyTalentRequestData.name, companyTalentRequestData.superstarUid)
            }
            delete companyTalentRequest.superstarUid;
        }

        if (companyTalentRequest['tagTeamUid']) {
            const companyTalentRequestTagTeam = TagTeams.findOne({
                'uid': companyTalentRequest.tagTeamUid
            });
            if (companyTalentRequestTagTeam) {
                await addTagTeamTalentRequests(companyTalentRequestTagTeam, [companyTalentRequest]);
            }
            else {
                console.log('tagTeam not found when creating companyTalentRequestData', companyTalentRequestData.name, companyTalentRequestData.tagTeamUid)
            }
            delete companyTalentRequest.tagTeamUid;
        }

        // Add action data ids
        if (companyTalentRequest.actionData['selectedTalentId']) {
            let actionDataTalent = Superstars.findOne({
                'uid': companyTalentRequest.actionData['selectedTalentId']
            });
            if (!actionDataTalent) {
                actionDataTalent = TagTeams.findOne({
                    'uid': companyTalentRequest.actionData['selectedTalentId']
                });
            }
            if (actionDataTalent) {
                companyTalentRequest.actionData['selectedTalentId'] = actionDataTalent.$loki;
            }
            else {
                console.log('object not found for talent request', companyTalentRequest.actionData);
                delete companyTalentRequest.actionData['selectedTalentId'];
            }
        }
        if (companyTalentRequest.actionData['selectedTeamId']) {
            let actionDataTeam = TagTeams.findOne({
                'uid': companyTalentRequest.actionData['selectedTeamId']
            });
            if (actionDataTeam) {
                companyTalentRequest.actionData['selectedTeamId'] = actionDataTeam.$loki;
            }
            else {
                console.log('object not found for talent request', companyTalentRequest.actionData);
                delete companyTalentRequest.actionData['selectedTeamId'];
            }
        }
        if (companyTalentRequest.actionData['selectedFactionId']) {
            let actionDataFaction = allFactions.find(x => {
                return x.uid === companyTalentRequest.actionData['selectedFactionId'];
            });
            if (actionDataFaction) {
                companyTalentRequest.actionData['selectedFactionId'] = actionDataFaction.$loki;
            }
            else {
                console.log('object not found for talent request', companyTalentRequest.actionData);
                delete companyTalentRequest.actionData['selectedFactionId'];
            }
        }
        if (companyTalentRequest.actionData['selectedChampionshipId']) {
            let actionDataChampionship = Championships.findOne({
                'uid': companyTalentRequest.actionData['selectedChampionshipId']
            });
            if (actionDataChampionship) {
                companyTalentRequest.actionData['selectedChampionshipId'] = actionDataChampionship.$loki;
            }
            else {
                console.log('object not found for talent request', companyTalentRequest.actionData);
                delete companyTalentRequest.actionData['selectedChampionshipId'];
            }
        }
        if (companyTalentRequest.actionData['selectedGimmickMatchId']) {
            let actionDataGimmickMatch = GimmickMatches.findOne({
                'uid': companyTalentRequest.actionData['selectedGimmickMatchId']
            });
            if (actionDataGimmickMatch) {
                companyTalentRequest.actionData['selectedGimmickMatchId'] = actionDataGimmickMatch.$loki;
            }
            else {
                console.log('object not found for talent request', companyTalentRequest.actionData);
                delete companyTalentRequest.actionData['selectedGimmickMatchId'];
            }
        }
        if (companyTalentRequest.actionData['selectedBrandId']) {
            let actionDataBrand = allBrands.find(x => {
                return x.uid === companyTalentRequest.actionData['selectedBrandId'];
            });
            if (actionDataBrand) {
                companyTalentRequest.actionData['selectedBrandId'] = actionDataBrand.$loki;
            }
            else {
                console.log('object not found for talent request', companyTalentRequest.actionData);
                delete companyTalentRequest.actionData['selectedBrandId'];
            }
        }
    }
    await addCompanyTalentRequests(company, companyTalentRequests);
}

async function createCompanyTournaments(companyTournamentsData, company) {
    let companyTournaments = [];
    for (let i = 0; i < companyTournamentsData.length; i++) {
        const companyTournamentData = companyTournamentsData[i];
        const companyTournament = {...Tournament(), ...companyTournamentData};
        Tournaments.insert(companyTournament);
        companyTournaments.push(companyTournament);

        if (companyTournament['winnerSuperstarUid']) {
            const tournamentWinnerSuperstar = Superstars.findOne({
                'uid': companyTournament['winnerSuperstarUid']
            });
            if (tournamentWinnerSuperstar) {
                await addSuperstarWonTournaments(tournamentWinnerSuperstar, [companyTournament]);
            }
            else {
                console.log('winnerSuperstar not found when creating companyTournamentData', companyTournamentData.name, companyTournamentData.winnerSuperstarUid)
            }
            delete companyTournament.winnerSuperstarUid;
        }

        if (companyTournament['winnerTagTeamUid']) {
            const tournamentWinnerTagTeam = TagTeams.findOne({
                'uid': companyTournament['winnerTagTeamUid']
            });
            if (tournamentWinnerTagTeam) {
                await addTagTeamWonTournaments(tournamentWinnerTagTeam, [companyTournament]);
            }
            else {
                console.log('winnerTagTeam not found when creating companyTournamentData', companyTournamentData.name, companyTournamentData.winnerTagTeamUid)
            }
            delete companyTournament.winnerTagTeamUid;
        }

        // Add company data ids
        if (companyTournament.companiesData) {
            for (const orgId in companyTournament.companiesData) {
                if (companyTournament.companiesData.hasOwnProperty(orgId)) {
                    if (companyTournament.companiesData[orgId]['participantIds']) {
                        const newParticipantIds = [];
                        for (const participantId of companyTournament.companiesData[orgId]['participantIds']) {
                            let participant = Superstars.findOne({
                                'uid': participantId
                            });
                            if (participant) {
                                newParticipantIds.push(participant.$loki);
                            }
                        }
                        companyTournament.companiesData[orgId]['participantIds'] = newParticipantIds;
                    }
                    if (companyTournament.companiesData[orgId]['injuredParticipantId']) {
                        let injuredParticipant = Superstars.findOne({
                            'uid': companyTournament.companiesData[orgId]['injuredParticipantId']
                        });
                        if (injuredParticipant) {
                            companyTournament.companiesData[orgId]['injuredParticipantId'] = injuredParticipant.$loki;
                        }
                    }
                }
            }
        }

    }
    await addCompanyTournaments(company, companyTournaments);
}

async function addAnnualTournamentOrganizationIds(allCompanies) {
    const companyTournaments = await getCompanyTournaments(allCompanies[0]);
    for (const tournament of companyTournaments) {
        if (tournament.companiesData) {
            for (const orgId in tournament.companiesData) {
                if (tournament.companiesData.hasOwnProperty(orgId) && orgId !== 'Indies') {
                    const tournamentOrganization = allCompanies.find(x => {
                        return x.uid === orgId;
                    });
                    if (tournamentOrganization) {
                        tournament.companiesData[tournamentOrganization.$loki] = tournament.companiesData[orgId];
                        delete tournament.companiesData[orgId]
                    }
                }
            }
        }
    }
}

function addSegmentConsequenceData(segment, allFactions, allChampionships, allBrands, allFeuds,
                                   allSegments, allMatches, allCompetitors) {
    if (segment['consequenceData']) {
        if (segment['consequenceData']['superstarUids']) {
            let consequenceObjects = Superstars.find({'uid': {'$in': segment['consequenceData']['superstarUids']}});
            if (consequenceObjects) {
                segment['consequenceData']['superstarUids'] = consequenceObjects.map(x => x.$loki);
            }
        }
        if (segment['consequenceData']['factionUids']) {
            let consequenceObjects = allFactions.filter(x => {
                return segment['consequenceData']['factionUids'].includes(x.uid);
            });
            if (consequenceObjects) {
                segment['consequenceData']['factionUids'] = consequenceObjects.map(x => x.$loki);
            }
        }
        if (segment['consequenceData']['factionConsequenceUids']) {
            let consequenceObjects = allFactions.filter(x => {
                return segment['consequenceData']['factionConsequenceUids'].includes(x.uid);
            });
            if (consequenceObjects) {
                segment['consequenceData']['factionConsequenceUids'] = consequenceObjects.map(x => x.$loki);
            }
        }
        if (segment['consequenceData']['leaderUid']) {
            let consequenceObject = Superstars.findOne({
                'uid': segment['consequenceData']['leaderUid']
            });
            if (consequenceObject) {
                segment['consequenceData']['leaderUid'] = consequenceObject.$loki;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['leaderUid'];
            }
        }
        if (segment['consequenceData']['brandUid']) {
            let consequenceObject = allBrands.find(x => {
                return x.uid === segment['consequenceData']['brandUid'];
            });
            if (consequenceObject) {
                segment['consequenceData']['brandUid'] = consequenceObject.$loki;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['brandUid'];
            }
        }
        if (segment['consequenceData']['talentUid']) {
            let consequenceObject = Superstars.findOne({
                'uid': segment['consequenceData']['talentUid']
            });
            if (!consequenceObject) {
                consequenceObject = TagTeams.findOne({
                    'uid': segment['consequenceData']['talentUid']
                });
            }
            if (consequenceObject) {
                segment['consequenceData']['talentUid'] = consequenceObject.$loki;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['talentUid'];
            }
        }
        if (segment['consequenceData']['competitorUid']) {
            let consequenceObject = allCompetitors.find(x => {
                return x.uid === segment['consequenceData']['competitorUid'];
            });
            if (consequenceObject) {
                segment['consequenceData']['competitorUid'] = consequenceObject.$loki;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['competitorUid'];
            }
        }
        if (segment['consequenceData']['feudUid']) {
            let consequenceObject = allFeuds.find(x => {
                return x.uid === segment['consequenceData']['feudUid'];
            });
            if (consequenceObject) {
                segment['consequenceData']['feudUid'] = consequenceObject.$loki;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['feudUid'];
            }
        }
        if (segment['consequenceData']['championshipUid']) {
            let consequenceObject = allChampionships.find(x => {
                return x.uid === segment['consequenceData']['championshipUid'];
            });
            if (consequenceObject) {
                segment['consequenceData']['championshipUid'] = consequenceObject.$loki;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['championshipUid'];
            }
        }
        if (segment['consequenceData']['matchOrSegmentUid']) {
            let matchOrSegmentType = 'segment';
            let consequenceObject = allSegments.find(x => {
                return x.uid === segment['consequenceData']['matchOrSegmentUid'];
            });
            if (!consequenceObject) {
                matchOrSegmentType = 'match';
                consequenceObject = allMatches.find(x => {
                    return x.uid === segment['consequenceData']['matchOrSegmentUid'];
                });
            }
            if (consequenceObject) {
                segment['consequenceData']['matchOrSegmentUid'] = consequenceObject.$loki;
                segment['consequenceData']['matchOrSegmentType'] = matchOrSegmentType;
            }
            else {
                console.log('object not found for segment consequenceData', segment['consequenceData']);
                delete segment['consequenceData']['matchOrSegmentUid'];
            }
        }
    }
}

async function createCompanyNews(companyNewsItemsData, company) {
    let companyNewsItems = [];
    for (let i = 0; i < companyNewsItemsData.length; i++) {
        const companyNewsItemData = companyNewsItemsData[i];
        const companyNewsItem = {...NewsItem(), ...companyNewsItemData};
        NewsItems.insert(companyNewsItem);
        companyNewsItems.push(companyNewsItem);
    }
    await addCompanyNewsItems(company, companyNewsItems);
}

async function createCompanyStoryChoices(companyStoryChoicesData, company) {
    let companyStoryChoices = [];
    for (let i = 0; i < companyStoryChoicesData.length; i++) {
        const companyStoryChoiceData = companyStoryChoicesData[i];
        const companyStoryChoice = {...StoryChoice(), ...companyStoryChoiceData};
        StoryChoices.insert(companyStoryChoice);
        companyStoryChoices.push(companyStoryChoice);
    }
    await addCompanyStoryChoices(company, companyStoryChoices);
}

async function createGameYearlyRankings(companyYearlyRankingsData, game) {
    let companyYearlyRankings = [];
    for (let i = 0; i < companyYearlyRankingsData.length; i++) {
        const companyYearlyRankingData = companyYearlyRankingsData[i];
        const companyYearlyRanking = {...YearlyRanking(), ...companyYearlyRankingData};
        YearlyRankings.insert(companyYearlyRanking);
        companyYearlyRankings.push(companyYearlyRanking);
    }
    await addGameYearlyRankings(game, companyYearlyRankings);
}

async function createCompanyDraft(companyDraftData, allRosters, company) {
    const companyDraft = {...Draft(), ...companyDraftData};
    Drafts.insert(companyDraft);

    // Add relationships
    if (companyDraft['rosterPickOrderIds'].length > 0) {
        const draftRosters = companyDraft['rosterPickOrderIds'].map(x => {
            return allRosters.find(r => r.uid === x);
        }).filter(x => x);
        companyDraft.rosterPickOrderIds = draftRosters.map(x => x.$loki);
        if (draftRosters.length > 0) {
            await addDraftRosters(companyDraft, draftRosters);
        }
    }
    if (companyDraft['currentPickRosterUid']) {
        const draftCurrentPickRoster = allRosters.find(x => {
            return x.uid === companyDraft.currentPickRosterUid;
        });
        if (draftCurrentPickRoster) {
            await setDraftCurrentPickRoster(companyDraft, draftCurrentPickRoster);
        }
        delete companyDraft.currentPickRosterUid;
    }
    if (companyDraft['protectedSuperstarsIds'].length > 0) {
        const protectedSuperstars = companyDraft['protectedSuperstarsIds'].map(x => {
            return Superstars.findOne({uid: x});
        }).filter(x => x);
        companyDraft.protectedSuperstarsIds = protectedSuperstars.map(x => x.$loki);
    }

    await addDraftCompanies(companyDraft, [company]);
}

async function createCompanyFeudItems(companyFeudItemsData, allFeuds, company) {
    let companyFeudItems = [];
    for (let i = 0; i < companyFeudItemsData.length; i++) {
        const companyFeudItemData = companyFeudItemsData[i];
        const companyFeudItem = {...FeudItem(), ...companyFeudItemData};
        FeudItems.insert(companyFeudItem);
        companyFeudItems.push(companyFeudItem);

        // Add feuds
        const feudItemFeuds = allFeuds.filter(x => {
            return x['feudItemUid'] === companyFeudItemData['uid'];
        });
        if (feudItemFeuds.length > 0) {
            await addFeudItemFeuds(companyFeudItem, feudItemFeuds);
        }
    }
    await addCompanyFeudItems(company, companyFeudItems);
}

async function createCompanySegmentItems(companySegmentItemsData, allSegments, company) {
    let companySegmentItems = [];
    for (let i = 0; i < companySegmentItemsData.length; i++) {
        const companySegmentItemData = companySegmentItemsData[i];
        const companySegmentItem = {...SegmentItem(), ...companySegmentItemData};
        SegmentItems.insert(companySegmentItem);
        if (!companySegmentItem['detachedItem']) {
            companySegmentItems.push(companySegmentItem);
        }

        // Add segments
        const segmentItemSegments = allSegments.filter(x => {
            return x['segmentItemUid'] === companySegmentItemData['uid'];
        });
        if (segmentItemSegments.length > 0) {
            await addSegmentItemSegments(companySegmentItem, segmentItemSegments);
        }
    }
    await addCompanySegmentItems(company, companySegmentItems);
}

async function createCompanyMessages(companyMessagesData, company) {
    let companyMessages = [];
    for (let i = 0; i < companyMessagesData.length; i++) {
        const companyMessageData = companyMessagesData[i];
        const companyMessage = {...Message(), ...companyMessageData};
        Messages.insert(companyMessage);
        if (!companyMessageData['detachedItem']) {
            companyMessages.push(companyMessage);
        }
    }
    await addCompanyMessages(company, companyMessages);
}

async function createCompanyPowerups(companyPowerupsData, company) {
    let companyPowerups = [];
    for (let i = 0; i < companyPowerupsData.length; i++) {
        const companyPowerupData = companyPowerupsData[i];
        const companyPowerup = {...Powerup(), ...companyPowerupData};
        Powerups.insert(companyPowerup);
        companyPowerups.push(companyPowerup);
    }
    await addCompanyPowerups(company, companyPowerups);
}

async function createCompanyFacilities(companyFacilitiesData, company) {
    let companyFacilities = [];
    for (let i = 0; i < companyFacilitiesData.length; i++) {
        const companyFacilityData = companyFacilitiesData[i];
        const companyFacility = {...Facility(), ...companyFacilityData};
        Facilities.insert(companyFacility);
        companyFacilities.push(companyFacility);
    }
    await addCompanyFacilities(company, companyFacilities);
}

async function createCompanyObjectives(companyObjectivesData, company) {
    let companyObjectives = [];
    for (let i = 0; i < companyObjectivesData.length; i++) {
        const companyObjectiveData = companyObjectivesData[i];
        const companyObjective = {...Objective(), ...companyObjectiveData};
        Objectives.insert(companyObjective);
        companyObjectives.push(companyObjective);

        // Create properties
        await createObjectiveProperties(companyObjectiveData['properties'], companyObjective);

        delete companyObjective.properties;
    }
    await addCompanyObjectives(company, companyObjectives);
}

async function createObjectiveProperties(objectivePropertiesData, objective) {
    let objectiveProperties = [];
    for (let i = 0; i < objectivePropertiesData.length; i++) {
        const objectivePropertyData = objectivePropertiesData[i];
        const objectiveProperty = {...Property(), ...objectivePropertyData};
        Properties.insert(objectiveProperty);
        objectiveProperties.push(objectiveProperty);

        // Add relationships
        if (objectiveProperty['superstarUids'].length > 0) {
            const propertySuperstars = Superstars.find({'uid': {'$in': objectiveProperty['superstarUids']}});
            if (propertySuperstars.length > 0) {
                await addPropertySuperstars(objectiveProperty, propertySuperstars);
            }
            else {
                console.log('superstar not found when creating objectivePropertyData', objectivePropertyData.name, objectivePropertyData.superstarUids)
            }
        }
        delete objectiveProperty.superstarUids;
        if (objectiveProperty['championshipUids'].length > 0) {
            const propertyChampionships = Championships.find({'uid': {'$in': objectiveProperty['championshipUids']}});
            if (propertyChampionships.length > 0) {
                await addPropertyChampionships(objectiveProperty, propertyChampionships);
            }
            else {
                console.log('championship not found when creating objectivePropertyData', objectivePropertyData.name, objectivePropertyData.championshipUids)
            }
        }
        delete objectiveProperty.championshipUids;
        if (objectiveProperty['gimmickMatchUids'].length > 0) {
            const propertyGimmickMatches = GimmickMatches.find({'uid': {'$in': objectiveProperty['gimmickMatchUids']}});
            if (propertyGimmickMatches.length > 0) {
                await addPropertyGimmickMatches(objectiveProperty, propertyGimmickMatches);
            }
            else {
                console.log('gimmickMatch not found when creating objectivePropertyData', objectivePropertyData.name, objectivePropertyData.gimmickMatchUids)
            }
        }
        delete objectiveProperty.gimmickMatchUids;
    }
    await addObjectiveProperties(objective, objectiveProperties);
}

async function createCompanyStaff(staffData, company) {
    let staff = [];
    for (let i = 0; i < staffData.length; i++) {
        const staffMember = await createStaffMember(staffData[i]);
        staff.push(staffMember);
    }
    await addCompanyStaff(company, staff);
}

async function createRosterStaff(staffData, roster) {
    let staff = [];
    for (let i = 0; i < staffData.length; i++) {
        const staffMember = await createStaffMember(staffData[i]);
        staff.push(staffMember);
    }
    await addRosterStaff(roster, staff);
}

async function createStaffMember(staffMemberData) {
    const staffMember = {...Staff(), ...staffMemberData};
    StaffMembers.insert(staffMember);

    // Add superstar object if present
    if (staffMember.superstarObjectData) {
        const staffSuperstarObject = {...Superstar(), ...staffMember.superstarObjectData};
        Superstars.insert(staffSuperstarObject);
        if (!globalUser.paid) {
            staffSuperstarObject.brandName = null;
        }
        staffSuperstarObject.pronoun = getRosterMemberPronoun(staffSuperstarObject);
        staffSuperstarObject.possessivePronoun = getRosterMemberPronoun(staffSuperstarObject, 'possessive');
        staffSuperstarObject.objectivePronoun = getRosterMemberPronoun(staffSuperstarObject, 'objective');
        setStaffSuperstarObject(staffMember, staffSuperstarObject);
        delete staffMember.superstarObjectData;
    }
    return staffMember;
}

async function createCompanyChampionshipReigns(championshipReignsData, championship) {
    let championshipReigns = [];
    for (let i = 0; i < championshipReignsData.length; i++) {
        const championshipReignData = championshipReignsData[i];
        const championshipReign = {...ChampionshipReign(championshipReignData['startMonth'],
                championshipReignData['startYear']), ...championshipReignData};
        ChampionshipReigns.insert(championshipReign);
        const championshipReignSuperstar = Superstars.findOne({
            'uid': championshipReignData.superstarUid
        });
        if (championshipReignSuperstar) {
            await addSuperstarChampionshipReigns(championshipReignSuperstar, [championshipReign])
        }
        else {
            console.log('reign superstar not found when creating game', championshipReign.name, championshipReign.superstarUid)
        }
        delete championshipReign.superstarUid;
        championshipReigns.push(championshipReign);
    }
    await addChampionshipChampionshipReigns(championship, championshipReigns);
}

async function createEventMatchContracts(eventData, companyChampionships,
                                         companyTournaments, event, newGameSettings) {
    let matchContracts = [];
    for (let i = 0; i < eventData['matchContracts'].length; i++) {

        const matchContractData = eventData['matchContracts'][i];

        let matchContractTalent;
        if (matchContractData['superstarUid']) {
            matchContractTalent = Superstars.findOne({
                'uid': matchContractData['superstarUid']
            });
        }
        if (matchContractData['tagTeamUid']) {
            matchContractTalent = TagTeams.findOne({
                'uid': matchContractData['tagTeamUid']
            });
        }

        if (matchContractTalent || (!matchContractData['superstarUid'] && !matchContractData['tagTeamUid'])) {
            const matchContract = {...MatchContract(), ...matchContractData};
            MatchContracts.insert(matchContract);
            matchContracts.push(matchContract);

            if (newGameSettings) {
                matchContract.awarded = true;
            }

            if (matchContract['superstarUid']) {
                await addSuperstarMatchContracts(matchContractTalent, [matchContract]);
                delete matchContract.superstarUid;
            }

            if (matchContract['tagTeamUid']) {
                await addTagTeamMatchContracts(matchContractTalent, [matchContract]);
                delete matchContract.tagTeamUid;
            }

            if (matchContract['championshipUid']) {
                const foundChampionship = companyChampionships.find(x => {
                    return x.uid === matchContract.championshipUid;
                });
                const matchContractChampionships = companyChampionships
                    .filter(x => checkAreChampionshipsEqual(x, foundChampionship));
                for (const matchContractChampionship of matchContractChampionships) {
                    await addChampionshipMatchContracts(matchContractChampionship, [matchContract]);
                }
                delete matchContract.championshipUid;
            }

            if (matchContract['tournamentUid']) {
                const matchContractTournament = companyTournaments.find(x => {
                    return x.uid === matchContract.tournamentUid;
                });
                if (matchContractTournament) {
                    await addTournamentMatchContracts(matchContractTournament, [matchContract]);
                }
                delete matchContract.tournamentUid;
            }
        }
        else {
            console.log('talent not found when creating matchContract', matchContractData.name, matchContractData.superstarUid, matchContractData.tagTeamUid)
        }
    }
    await addEventMatchContracts(event, matchContracts);
}

async function createEventStreaks(eventData, event) {
    let streaks = [];
    for (let i = 0; i < eventData['streaks'].length; i++) {
        const streakData = eventData['streaks'][i];

        let streakTalent;
        if (streakData['superstarUid']) {
            streakTalent = Superstars.findOne({
                'uid': streakData.superstarUid
            });
        }
        if (streakData['tagTeamUid']) {
            streakTalent = TagTeams.findOne({
                'uid': streakData.tagTeamUid
            });
        }

        if (streakTalent) {
            const streak = {...Streak(), ...streakData};
            Streaks.insert(streak);
            streaks.push(streak);
            if (streak['superstarUid']) {
                await addSuperstarStreaks(streakTalent, [streak]);
                delete streak.superstarUid;
            }
            if (streak['tagTeamUid']) {
                await addTagTeamStreaks(streakTalent, [streak]);
                delete streak.tagTeamUid;
            }
        }
        else {
            console.log('talent not found when creating streak', streakData)
        }
    }
    await addEventStreaks(event, streaks);
}

async function deleteGameRequest({dbUid} = {}) {  // delete_game_view
    let data = {};
    await deleteDb(dbUid);
    globals.game.id = null;
    removeGameFromLocalStorage(dbUid);
    return data;
}

async function getUserGames() {  // get_user_games
    let allGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];

    // Don't get scenario games todo test that scenarios don't appear here
    let activeGames = allGames.filter(x => !x.scenarioId);

    // Sort by last played
    activeGames.sort((a, b) => b.datetimeLastPlayed - a.datetimeLastPlayed || b.$loki - a.$loki);

    // Limit free user's games shown
    if (!globalUser.paid) {
        activeGames = activeGames.slice(0, 1)
    }

    // Get last played
    for (let x of activeGames) {
        if (x.datetimeLastPlayed) {
            x.lastPlayed = getTimeDiffHuman(x.datetimeLastPlayed, new Date()) + ' ago';
        }
    }

    return activeGames;
}

async function getGameSaveData(game) {
    // Get game's attributes
    let gameData = {uid: game.$loki, name: game.name, editName: game.editName, settings: game.settings,
        scenarioId: game.scenarioId, datetimeLastPlayed: game.datetimeLastPlayed};

    // Get main user company's name
    const gameCompanies = await getGameCompanies(game);
    const userCompany = gameCompanies.find(x => x.userControlled);
    gameData.companyName = userCompany.name;
    gameData.storyName = userCompany.storyName;

    // Get display month/year
    [gameData.month, gameData.year] = getNextMonth(game.monthCount, 0, game.year, true);
    gameData.year += 1;

    // Get player names for local multiplayer
    if (game.settings.control_multiple_companies) {
        const userControlledCompanies = gameCompanies.filter(x => x.userControlled);
        gameData.playerNames = userControlledCompanies.map(x => x.playerName);
    }

    // Get next event's name
    let userCompanyEvents = await getCompanyEvents(userCompany);
    if (userCompanyEvents) {
        gameData.nextEventName = userCompanyEvents[userCompanyEvents.length - 1].name;
    }

    return gameData;
}

function getNextMonth(month, addMonths = 0, year = null, calendar = false) {  // get_next_month
    let endMonth = calendar ? 12 : 11;
    let nextMonth = month + 1;

    if (month === endMonth) {
        nextMonth = 0;
        if (year !== null) {
            year += 1
        }
    }

    if (addMonths === 0) {
        if (year !== null) {
            return [nextMonth, year];
        }
        return nextMonth;
    }
    else {
        return getNextMonth(nextMonth, addMonths - 1, year, calendar)
    }
}

async function getGameCurrentUserCompany(game) {
    // Get current company (for local multiplayer)
    if (game.currentCompanyId) {
        return getGameCurrentCompany(game)
    }
    // Otherwise get first user controlled company
    const gameCompanies = await getGameCompanies(game);
    return gameCompanies.find(x => x.userControlled);
}

async function getGameMainUserCompany(game) {
    // Get first user company
    const gameCompanies = await getGameCompanies(game);
    return gameCompanies.find(x => x.userControlled);
}

async function getGameActiveCompanies(game) {  // Previously get_all_companies
    // Get companies that don't have 'Inactive' status
    const allCompanies = await getGameCompanies(game);
    return allCompanies.filter(x => x.operatingStatus !== 'Inactive');
}

async function getHomePageData(game) {  // Previously game_loop
    let data = {};
    let company = await getGameCurrentUserCompany(game);
    let saveDatabase = false;
    let mainCompany = await getGameMainUserCompany(game);
    let annualTournament = (await getCompanyTournaments(mainCompany)).find(x => x.annualTournament && x.status !== 'ended');

    // Process forming new company
    try {
        if (company.newCompanyData?.monthsToForm !== undefined) {
            if (company.newCompanyData.monthsToForm <= 0 && !['selecting', 'running'].includes(annualTournament?.status)) {
                await formNewCompany();
                saveDatabase = true;
                company = await getGameCurrentUserCompany(game);
                mainCompany = await getGameMainUserCompany(game);
                annualTournament = (await getCompanyTournaments(mainCompany)).find(x => x.annualTournament && x.status !== 'ended');
                // Save to local storage
                await saveGameDataToLocalStorage(game);
            }
        }
    }
    catch (error) {
        captureError(error);
        await loadDb(db.filename);
    }

    const parentEvents = await getCompanyParentEvents(company);
    const latestEvent = await getCompanyLatestEvent(company);
    const user = loadUser();

    // Get event card data
    let eventCardData = await getEventCardData();
    data['eventData'] = eventCardData['eventData'];
    data['maximumMatchesAndSegments'] = eventCardData['maximumMatchesAndSegments'];
    data['minimumMatchesAndSegments'] = eventCardData['minimumMatchesAndSegments'];
    data['matchesAndSegments'] = eventCardData['matchesAndSegments'];

    // Get dialogs for Passion of Wrestling story
    if (mainCompany.storyName === 'passion') {

        // Get introduction dialog
        if (game.monthCount === 0 && game.year === 0) {
            data['showPowIntroduction'] = true
        }

        // Get reaction dialogs
        data['powReactionDialogs'] = await getPowProducerReactionDialogs(company);

        // Check if story failed
        const powFailureEnding = (await getCompanyStoryChoices(company)).find(x => x.choice === 'failure_ending');
        data['powStoryFailureEnding'] = !!powFailureEnding;
    }

    // Get state for tutorial
    if (mainCompany.storyName === 'tutorial') {
        data['tutorialState'] = await getTutorialStateName(mainCompany)
    }

    // Check for Running Buyout status in companies
    let [runningBuyout, companyToBuyout] = await runningBuyoutCheck(company, game);
    if (runningBuyout) {
        data['buyoutData'] = await getBuyoutData(companyToBuyout, company);
    }

    // Check for forming new company
    if (company.newCompanyData?.monthsToForm !== undefined) {
        data['newCompanyData'] = company.newCompanyData;
        if (data['newCompanyData']['monthsToForm'] === 1) {
            data['newCompanyData']['selectionsData'] = await getNewCompanySelectionsData(company);
        }
    }

    // Check for yearly updates
    if (getCompanyMonth(company, game) === 0 && !company.yearlyCheckRun) {
        try {
            await processSuperstarsYearlyChanges(company)
        } catch (error) {
            captureError(error)
        }
    }

    // Get game data
    data['monthCount'] = game.monthCount;
    data['companyMonth'] = getCompanyMonth(company, game);
    data['year'] = game.year;
    data['competitorsPresent'] = game.competitorsPresent;
    data['awardsRun'] = game.awardsRun;
    data['gameSettings'] = game.settings;
    data['userSettings'] = (user) ? user.settings : {};
    data['marketSize'] = game.marketSize;

    // Get company data
    data['companyName'] = company.name;
    data['currentMonth'] = await getCurrentMonth(company, parentEvents);
    data['realYear'] = company.realYear;
    data['style'] = company.style;
    data['points'] = company.points;
    data['fans'] = company.fans;
    data['reputation'] = company.reputation;
    data['story'] = company.storyName;
    data['owner'] = company.ownerName;
    data['trainingCallupRun'] = company.trainingCallupRun;
    data['playerName'] = company.playerName;

    // Get random events that are current and have choices not entered
    const randomEvents = (await getCompanyRandomEvents(company)).filter(x => x.monthsRemaining > 0 &&
        x.choices.length && !x.selectedChoice);
    data['randomEvents'] = await Promise.all(randomEvents.map(x => getRandomEventData(x)));

    // Get trade offers
    const receivedTradeOffers = await getCompanyReceivedTradeOffers(company);
    data['tradeOffers'] = await Promise.all(receivedTradeOffers.map(x => getTradeOfferData(x)));

    // Get talent offers
    data['talentOffers'] = [];
    const acceptedNegotiations = (await getCompanyReceivedNegotiations(company))
        .filter(x => x.status === 'accepted_by_talent');
    for (const acceptedNegotiation of acceptedNegotiations) {
        const negotiationTalent = await getNegotiationTalent(acceptedNegotiation);
        if (negotiationTalent && (await getRosterMemberSuperstars(negotiationTalent)).length) {
            // Don't show multiple offers separately
            if (!data['talentOffers'].some(x => x['name'] === negotiationTalent.name)) {
                data['talentOffers'].push(await getTalentOfferData(acceptedNegotiation));
            }
        } else {
            await Negotiations.remove(acceptedNegotiation); // For compatibility with old games
            saveDatabase = true;
        }
    }

    // Get created talent requests
    try {
        const companyTalentRequests = await getCompanyTalentRequests(company);
        data['talentRequestsData'] = [];
        const createdTalentRequests = companyTalentRequests.filter(x => x.status === 'created');
        for (const createdTalentRequest of createdTalentRequests) {
            data['talentRequestsData'].push(await getTalentRequestData(createdTalentRequest));
        }

        // Delete finished talent requests, get data for major ones
        const finishedTalentRequests = companyTalentRequests.filter(x => x.status === 'completed' || x.status === 'failed');
        if (!data['randomEvents'].length && !data['talentOffers'].length && !data['tradeOffers'].length && !data['buyoutData'] &&
            !(game.monthCount === 10 && game.competitorsPresent && !game.awardsRun) &&
            !(data.newCompanyData?.monthsToForm === 2 && !data.newCompanyData?.companyDetails) &&
            !(data.newCompanyData?.monthsToForm === 1 && !data.newCompanyData?.talentDetails)) {
            for (const finishedTalentRequest of finishedTalentRequests) {
                if (talentRequestsData[finishedTalentRequest.type]['importance'] === 'major') {
                    data['talentRequestsData'].push(await getTalentRequestData(finishedTalentRequest));
                }
                await TalentRequests.remove(finishedTalentRequest);
                saveDatabase = true;
            }
        }
    } catch (error) {
        captureError(error)
    }

    // Set news month/year
    game.newsMonth = game.monthCount;
    game.newsYear = game.year;

    // Available callups message
    let availableCallupsMessage = await checkForAvailableCallupsMessage(company, game);
    if (availableCallupsMessage) {
        await addCompanyMessages(company, [availableCallupsMessage]);
        saveDatabase = true;
    }

    // Delete old messages
    let messagesToDelete = (await getCompanyMessages(company))
        .filter(x => getMonthsDifference(game.monthCount, game.year, x.month, x.year) > 4);
    for (let message of messagesToDelete) {
        await Messages.remove(message);
        saveDatabase = true;
    }

    // Process yearly rankings in January
    try {
        if (company === mainCompany && data['currentMonth'] === 0 &&
            !latestEvent.weeklyShow && latestEvent.name !== 'Weekly Show' && !latestEvent.temporaryEvent &&
            !(game.year === 0 && game.monthCount === 0)) {
            data['yearlyRankingData'] = await processYearlyRanking(game, mainCompany);
        }
    } catch (error) {
        captureError(error)
    }

    // Get annual tournament data
    if (annualTournament) {
        data['annualTournamentData'] = await getAnnualTournamentData(annualTournament, company, mainCompany, game);
    }

    // Get draft data if running
    let draft = await getCompanyDraft(company);
    if (draft && !draft.postEndRun) {
        data['draftData'] = await getDraftData(draft, company);
    }

    // Objectives review and messages
    try {
        if (!data['draftData']) {
            let reviewData = await reviewObjectives(company, game);
            let objectivesMessage = await checkToAddCurrentObjectivesMessage(company);
            if (objectivesMessage) {
                await addCompanyMessages(company, [objectivesMessage]);
            }
            if (reviewData['numberOfCompletedObjectives']) {
                saveDatabase = true;
            }
        }
    } catch (error) {
        captureError(error)
    }

    if (saveDatabase) {
        db.saveDatabase()
    }

    // Get dashboard data
    try {
        data['dashboardData'] = await getDashboardData(company, game);
    } catch (error) {
        captureError(error)
    }

    // Get unread messages
    const unreadMessages = await getCompanyUnreadMessages(company);
    data['unreadMessages'] = unreadMessages.length;

    return data;
}

async function markGameAsPlaying(game) {

    // Set global game id
    globals.game.id = game.$loki;

    // Update datetime last played
    game.datetimeLastPlayed = Date.now();

    db.saveDatabase();

    return game;
}

async function getOptionsData() {  // Previously get_user_settings
    let data = {};
    const currentGame = await getCurrentGame();
    const user = loadUser();

    if (!currentGame) {
        return data;
    }

    data['numberOfWeeklyShows'] = currentGame.numberOfWeeklyShows;
    data['userSettings'] = (user) ? user.settings : {};
    data['gameSettings'] = currentGame.settings;
    data['dateTimeLastCloudSave'] = currentGame.dateTimeLastCloudSave;

    return data;
}

async function changeNumberOfWeeklyShows(value) {  // Previously change_number_of_weekly_shows_option
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Return error if upcoming event is weekly show
    const upcomingEvent = await getCompanyLatestEvent(userCompany);
    if (upcomingEvent.weeklyShow || upcomingEvent.name === 'Weekly Show') {
        data['error'] = 'weekly-show';
        data['numberOfWeeklyShows'] = currentGame.numberOfWeeklyShows;
        return data;
    }

    // Check if no companies have ended their turn in local multiplayer
    if (currentGame.settings['control_multiple_companies']) {
        const userControlledCompanies = await getUserControlledCompanies(currentGame);
        const userControlledCompaniesEnded = userControlledCompanies.filter(x => x.turnStatus === 'ended');
        if (userControlledCompaniesEnded.length > 0) {
            data['error'] = 'turn-ended';
            data['numberOfWeeklyShows'] = currentGame.numberOfWeeklyShows;
            return data;
        }
    }

    // Change number of weekly shows
    if (value !== null && value >= 0 && value <= 4) {
        currentGame.numberOfWeeklyShows = value;
        db.saveDatabase();
    }

    return data;
}

async function getUserControlledCompanies(game) {  // Previously get_user_controlled_companies
    // Get all user controlled companies
    const gameActiveCompanies = await getGameActiveCompanies(game);
    return gameActiveCompanies.filter(x => x.userControlled);
}

async function changeUserSetting(settingName, settingValue) {  // Previously change_user_game_settings
    let data = {};
    const user = loadUser();

    // Change user setting
    if (user) {
        user.settings[settingName] = settingValue;
        saveUser(user);
        data['userSettings'] = user.settings;
    }
    else {
        data['error'] = 'not-logged-in'
    }

    return data;
}

async function changeUserMatchResultSetting({setting} = {}) {  // _change_user_match_result_setting
    let data = {};
    const user = loadUser();

    // Change user setting
    if (user) {
        user.settings['matchResult'] = setting;
        saveUser(user);
    }

    return data;
}

async function changeGameSetting(settingName, settingValue) {  // Previously change_game_settings
    let data = {};
    const currentGame = await getCurrentGame();

    if (settingName === 'sandbox_mode_enabled') {
        data['error'] = 'change-not-allowed';
        return data;
    }

    // Change user setting
    if (currentGame) {
        currentGame.settings[settingName] = settingValue;
        db.saveDatabase();
        data['gameSettings'] = currentGame.settings;
    }
    else {
        data['error'] = 'game-not-found'
    }

    return data;
}

async function getUserInfo({}) {  // get_user_info
    const user = loadUser();

    let data = JSON.parse(JSON.stringify(user));
    data['talentRequestTypesCompletedData'] = [];
    for (const requestType of user.talentRequestTypesCompleted) {
        let requestData = talentRequestsData[requestType];
        if (requestData) {
            data['talentRequestTypesCompletedData'].push(requestData['display_name']);
        }
    }
    data['talentRequestTypesCompletedData'].sort();
    data['talentRequestTypesTotal'] = Object.keys(talentRequestsData).length;

    return data;
}

async function saveGameDataToLocalStorage(game, dbUid) {
    let jowGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    if (!dbUid) {
        dbUid = db.filename;
    }

    let gameSaveData = await getGameSaveData(game);
    gameSaveData['dbUid'] = dbUid;

    let gameDataIndex = jowGames.findIndex(x => x.dbUid === dbUid);
    if (gameDataIndex >= 0) {
        jowGames[gameDataIndex] = gameSaveData
    }
    else {
        jowGames.push(gameSaveData);
    }

    window.localStorage.setItem("jowGames", JSON.stringify(jowGames));
}

function removeGameFromLocalStorage(dbUid) {
    let jowGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    jowGames = jowGames.filter(x => x.dbUid !== dbUid);
    window.localStorage.setItem("jowGames", JSON.stringify(jowGames));
}

async function createGameInDatabase(gameData, gameSettings) {
    // Create db for game
    let dbUid = self.crypto.randomUUID ? self.crypto.randomUUID() : generateUUID();
    await loadDb(dbUid);

    // Create game from data
    const createdGame = await createGame(gameData, gameSettings);

    // Set datetimeLastPlayed and save
    await markGameAsPlaying(createdGame);

    // Save to local storage
    await saveGameDataToLocalStorage(createdGame, dbUid);

    return createdGame;
}

async function removePaidFeatures(game) {
    let company = await getGameMainUserCompany(game);

    // Remove staff
    for (let staffMember of await getCompanyStaff(company)) {
		await StaffMembers.remove(staffMember);
	}

    // Downgrade facilities
    for (let facility of await getCompanyFacilities(company)) {
        facility.level = 1
    }

    // Remove unlockable feud/segment items
    let unlockableFeudItems = standardFeudItemsData.filter(x => !x.unlocked).map(x => x.name);
    let unlockableSegmentItems = standardSegmentItemsData.filter(x => !x.unlocked).map(x => x.name);
    for (let feudItem of (await getCompanyFeudItems(company)).filter(x => x.unlocked)) {
        if (unlockableFeudItems.includes(feudItem.name)) {
            feudItem.unlocked = false
        }
    }
    for (let segmentItem of (await getCompanySegmentItems(company)).filter(x => x.unlocked)) {
        if (unlockableSegmentItems.includes(segmentItem.name)) {
            segmentItem.unlocked = false
        }
    }

    // Remove custom segments
    for (let segmentItem of (await getCompanySegmentItems(company)).filter(x => x.custom)) {
        await removeCompanySegmentItems(company, [segmentItem]);
    }

    // Remove unlocked powerups
    for (let powerup of await getCompanyPowerups(company)) {
        if (['Neural Control', 'Neural Control+', 'Cyborg'].includes(powerup.name)) {
            await Powerups.remove(powerup);
        }
    }

    // Remove brands
    let mainRoster = await getCompanyRosterByType(company, 'main');
    let rosterBrands = await getRosterBrands(mainRoster);
    if (rosterBrands.length) {
        let rosterSuperstars = await getRosterSuperstars(mainRoster);
        let companyChampionships = await getCompanyChampionships(company);
        let parentEvents = await getCompanyParentEvents(company);
        let latestEvent = await getCompanyLatestEvent(company);
        for (let brand of rosterBrands) {
            await removeRosterBrands(mainRoster, [brand]);
            for (const x of [...rosterSuperstars, ...parentEvents, ...companyChampionships]) {
                if (x.brandName === brand.name) {
                    removeObjectBrand(x)
                }
            }
            if (!latestEvent.weeklyShow) {
                if (latestEvent.brandName === brand.name) {
                    removeObjectBrand(latestEvent)
                }
            }
        }
    }

    db.saveDatabase();
}

async function addPaidFeatures(game) {
    let company = await getGameMainUserCompany(game);

    // Add staff
    let companyStaff = [];
    for (let role of staffRoles) {
        let staffMember = await generateStaffMember(role, 1);
        await addCompanyStaff(company, [staffMember]);
        companyStaff.push(staffMember);
    }

    for (let facility of await getCompanyFacilities(company)) {
        facility.staffNeverHired = false
    }

    // Add staff messages
    let mainRoster = await getCompanyRosterByType(company, 'main');
    let mainRosterSuperstars = await getRosterSuperstars(mainRoster);

    let doctor = companyStaff.find(x => x.role === 'doctor');
    let newMessage = await createNewCompanyDoctorMessage(mainRosterSuperstars.filter(x => x.injured), 0, 0, doctor);
    await addCompanyMessages(company, [newMessage]);

    let trainer = companyStaff.find(x => x.role === 'trainer');
    newMessage = await createNewCompanyTrainerMessage(0, 0, trainer);
    await addCompanyMessages(company, [newMessage]);

    let scout = companyStaff.find(x => x.role === 'scout');
    newMessage = await createNewCompanyScoutMessage(0, 0, scout);
    await addCompanyMessages(company, [newMessage]);

    let producer = companyStaff.find(x => x.role === 'producer');
    newMessage = await createNewCompanyProducerMessage(0, 0, producer);
    await addCompanyMessages(company, [newMessage]);

    let talentManager = companyStaff.find(x => x.role === 'talent_manager');
    newMessage = await createNewCompanyTalentManagerMessage(0, 0, talentManager);
    await addCompanyMessages(company, [newMessage]);

    db.saveDatabase();
}

export {createGame, createScenarioFromScenarioData, getUserGames, getNextMonth,
    getGameCurrentUserCompany, getHomePageData, markGameAsPlaying, getGameActiveCompanies, getOptionsData,
    changeNumberOfWeeklyShows, changeUserSetting, changeGameSetting, getGameMainUserCompany, changeUserMatchResultSetting,
    getUserControlledCompanies, createGameFromScenarioData, deleteGameRequest, getUserInfo,
    saveGameDataToLocalStorage, removeGameFromLocalStorage, createGameInDatabase, getGameSaveData, removePaidFeatures,
    addPaidFeatures}
